import { EnShift } from './../enum/en-shift.enum';
import { EnTypedValue } from '../enum/en-typed-value.enum';
import { ITypedValue } from '../interface/ityped-value';
import { IBasic } from '../interface/ibasic';

import { Injectable } from '@angular/core';

/* @classdesc Biblioteca de funções globais.
 * OBS: Não será possível utilizar o método de Log nessa classe, pois, o mesmo depende da GlobalService.
 */
@Injectable({ providedIn: 'root' })
export class GlobalService {
  // Constants:
  GE_NOT_INFORMED = 'NÃO INFORMADO';
  GE_EMPTY = '#VAZIO#';

  exprConjuncao = /\s(de|do|o|a|e|dos|da|das|de|para|se)\s/gi;

  arrayOperatorMathSimbol: any[] = new Array('+', '-', '/', '*');
  arrayMathSimbol: any[] = new Array('+', '-', '%', '/', '*', '=', ' ', '(', ')', '[', ']', ',', '.', '{', '}');
  arrayOfNumbers: any[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  arrayOfMonthsPtBr: any[] = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];
  // url encoding
  arrayEncodingCharCode: any[] = new Array('%23');
  arrayEncodingChar: any[] = new Array('#');

  // https://sistema.medlogic.com.br/Intranet/Arquivos/Word/EVOLU%C3%87%C3%83O%20CL%C3%8DNICA-172040.docx

  arrayEncodingCharAll: any[] = new Array(
    '%',
    ' ',
    '!',
    '"',
    '#',
    '$',
    '&',
    "'",
    '(',
    ')',
    '*',
    '+',
    ',',
    '-',
    '.',
    '/',
    'Ç',
    'Ã',
    'Í'
  );

  arrayEncodingCharCodeAll: string[] = new Array(
    '%25',
    '%20',
    '%21',
    '%22',
    '%23',
    '%24',
    '%26',
    '%27',
    '%28',
    '%29',
    '%2A',
    '%2B',
    '%2C',
    '%2D',
    '%2E',
    '%2F',
    '%C3%87',
    '%C3%83',
    '%C3%8'
  );

  EMPTY_CHAR = '#VAZIO#';
  NOITEM_TEXT = 'Não informado';
  NAO_RECALCULAR_ITEM = '#CARREGANDO#';
  // Variável utilizada para impedir que o retorno de uma
  // função de servidor que atualiza o valor assincro substitua
  // também no retorno sincrono.

  private GE_EMPTY_STRINGS = [this.EMPTY_CHAR, this.NAO_RECALCULAR_ITEM, this.NOITEM_TEXT, 'null', 'undefined'];

  private replace: any[] = [
    { de: 'Á', para: 'A' },
    { de: 'É', para: 'E' },
    { de: 'Í', para: 'I' },
    { de: 'Ó', para: 'O' },
    { de: 'Ú', para: 'U' },
    { de: 'À', para: 'A' },
    { de: 'È', para: 'E' },
    { de: 'Ì', para: 'I' },
    { de: 'Ò', para: 'O' },
    { de: 'Ù', para: 'U' },
    { de: 'Ä', para: 'A' },
    { de: 'Ë', para: 'E' },
    { de: 'Ï', para: 'I' },
    { de: 'Ö', para: 'O' },
    { de: 'Ü', para: 'U' },
    { de: 'Ã', para: 'A' },
    { de: 'Õ', para: 'O' },
    { de: 'Â', para: 'A' },
    { de: 'Ê', para: 'E' },
    { de: 'Î', para: 'I' },
    { de: 'Ô', para: 'O' },
    { de: 'Û', para: 'U' },
    { de: 'Ç', para: 'C' }
  ];

  // Constants:
  arrayOfMonthsAbrevPtBr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  arrayOfWeekDays = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado'
  ];
  arrayOfWeekDaysAbrev = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  arrayOfWeekDaysAbrevMin = ['Do', 'Sg', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'];
  genderAbrev = ['M', 'F'];
  gender = ['Masculino', 'Feminino'];
  stateAbrev = [
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MG',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'PR',
    'RJ',
    'RN',
    'RO',
    'RR',
    'RS',
    'SC',
    'SE',
    'SP',
    'TO'
  ];
  state = [
    'Acre',
    'Alagoas',
    'Amazonas',
    'Amapá',
    'Bahia',
    'Ceará',
    'Distrito Federal',
    'Espírito Santo',
    'Goiás',
    'Maranhão',
    'Minas Gerais',
    'Mato Grosso do Sul',
    'Mato Grosso',
    'Pará',
    'Paraíba',
    'Pernambuco',
    'Piauí',
    'Paraná',
    'Rio de Janeiro',
    'Rio Grande do Norte',
    'Rondônia',
    'Roraima',
    'Rio Grande do Sul',
    'Santa Catarina',
    'Sergipe',
    'São Paulo',
    'Tocantins'
  ];

  // names
  namesDoctorFiction = [
    'Dra.Thirteen',
    'Dra.Ellie Bartowski',
    'Dra.Meredith Grey',
    'Dra.Elliot Reid',
    'Dra.Sara Tancredi',
    'Dr.Carlisle Cullen',
    'Dra.Izzie Stevens',
    'Dra.Juliet Burke',
    'Dr.Patch Adams',
    'Dr.Derek Shepherd',
    'Dr.Jack Shephard',
    'Dra.Alisson Cameron',
    'Dr.Drake Ramoray',
    'Dr.Al Robbins',
    'Dr.Albieri'
  ];

  // 		let caracterInvalido:Array = ["/", "<", ">"];
  caracterInvalido = ['</', '<'];
  // 		let caracterSubstituto:Array = ["-", " menor que ", " maior que "];
  caracterSubstituto = ['/', ' '];

  regexEntreAspas: RegExp = /("[\w\s,!@#$%ˆ&*()-_+=[\]\\|;:'/?.>,<{}]*") /gi;

  testExpressions: any[] = [
    [/(dd\/mm\/yyyy hh:mm:ss)/i, this.func_ddmmyyyyhhmmss],
    [/(dd\/mm\/yyyy hh:mm)/i, this.func_ddmmyyyyhhmm],
    [/(dd\/mm\/yyyy)/i, this.func_ddmmyyyy],
    [/(dd\/mm)/i, this.func_ddmm],
    [/(mm\/yyyy)/i, this.func_mmyyyy],
    [/(hh:mm:ss)/i, this.func_hhmmss],
    [/(hh:mm)/i, this.func_hhmm],
    [/(mm:ss)/i, this.func_mmss],
    [/(D)/, this.func_D],
    [/(d)/, this.func_d],
    [/(M)/, this.func_M],
    [/(m)/, this.func_m],
    [/(y)/i, this.func_y],
    [/(h)/i, this.func_h],
    [/(mm)/i, this.func_mm],
    [/(s)/i, this.func_s],
    [/(w)/i, this.func_w]
  ];

  ASCII_START = 0;
  ASCII__EXTENDED_START = 128;
  ASCII_END = 167;
  ASCII_EXTENDED_END = 255;
  ASCII_SPECIAL: any[] = [8226]; // 8226 • (bullet do Word)
  ASCII_SPECIAL_REPLACE: any[] = ['- '];

  constructor() { }

  // tslint:disable-next-line: member-ordering
  forceMobile = true;
  /* Checa se o dispositivo atual é móvel */
  isMobile(): boolean {
    // var isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
    return this.forceMobile && true;
  }
  isAndroid(): boolean {
    const isAndroid = navigator?.userAgent?.toLowerCase().match(/android/i) !== null;
    return isAndroid;
  }

  // Se _objContainer = null chamará uma janela de mensagem javascript
  /* @classdesc Deverá exibir uma manesagem para o usuário na tela e um botão de OK */
  Mensagem(objContainer: any, mensagem: string): void {
    if (objContainer) {
    } else {
    }
  }

  /*
   * Remove o último caracter de uma string (não altera a string apenas retorna outra sem o caracter)
   * @param _string
   * @return
   *
   */
  RemoveLastChar(str: string): string {
    try {
      return str.substring(0, str.length - 1);
    } catch (error: any) {
      console.log(this.constructor.name, 'RemoveLastChar', error.message);
    }
  }

  /* Substitui a última ocorrência encontrada do _textToSearch por _textToReplace. */
  replaceLast(originalText: string, textToSearch: string, textToReplace: string): string {
    try {
      const a = originalText.split('');
      a[originalText.lastIndexOf(textToSearch)] = textToReplace;
      return a.join('');
    } catch (error: any) {
      console.log(this.constructor.name, 'replaceLast', error.message);
    }
    return originalText;
  }

  /* Remove a última ocorrência encontrada do _textToSearch. */
  removeLastOcurrence(originalText: string, textToSearch: string): string {
    try {
      return this.replaceLast(originalText, textToSearch, '');
    } catch (error: any) {
      console.log(this.constructor.name, 'replaceLast', error.message);
    }
    return originalText;
  }

  /*@method RemoveFirstChar
   * Retorna uma string com o primeiro caracter da _string fornecida removido.
   */
  RemoveFirstChar(str: string): string {
    try {
      return str.substring(1);
    } catch (error: any) {
      console.log(this.constructor.name, 'RemoveFirstChar', error.message);
    }
  }

  // Acrescenta aspas duplas
  Quote(str: string): string {
    try {
      return '"' + str + '"';
    } catch (error: any) {
      console.log(this.constructor.name, 'Quote', error.message);
    }
  }

  /*
   * Retorna a url codificada para ser possível acessar
   * @param _url
   * @return
   *
   */
  UrlEncode(url: string): string {
    try {
      for (let i = 0, max: number = this.arrayEncodingChar.length; i < max; i++) {
        url = this.ReplaceAll(url, this.arrayEncodingChar[i], this.arrayEncodingCharCode[i]);
      }
      return url;
    } catch (error: any) {
      console.log(this.constructor.name, 'UrlEncode', error.message);
    }
  }
  UrlEncodeAll(url: string): string {
    try {
      for (let i = 0, max: number = this.arrayEncodingCharAll.length; i < max; i++) {
        url = this.ReplaceAll(url, this.arrayEncodingCharAll[i], this.arrayEncodingCharCodeAll[i]);
      }
      return url;
    } catch (error: any) {
      console.log(this.constructor.name, 'UrlEncodeAll', error.message);
    }
  }

  /* Join different parts of an url join them with "/".
  * It will filter removing all empty parts.
  */
  urlJoin(parts: string[]): string {
    try {
      // const protocol = parts.find(f => f.startsWith('https://')) ? 'https://' : 'http://';
      // parts[0] = parts[0].replace(protocol, '');
      // let url = parts
      //   .reduce((a, b) => a.concat(b.split('/')), [])
      //   .filter(f => !this.isNullOrEmpty(f))
      //   .join('/');
      // // FIXME: Por algum motivo na substituição de variáveis # está se tornando V. Necessário retornar pois isso
      // // é o que evita problemas com o roteamento app angular (SPA)
      // url = url.replace('/V/', '/#/');
      // return `${protocol}${url}`;
      return this.combineURLs(parts[0], parts.slice(1).join('/'));
    } catch (error: any) {
      console.log(this.constructor.name, 'urlJoin', error.message);
    }
    return parts.join('/');
  }

  combineURLs(baseURL: string, relativeURL: string): string {
    return relativeURL
      ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
      : baseURL;
  }

  protected concatAndResolveUrl(url, concat): string {
    const url1 = url.split('/');
    const url2 = concat.split('/');
    const url3 = [];
    for (let i = 0, l = url1.length; i < l; i++) {
      if (url1[i] === '..') {
        url3.pop();
      } else if (url1[i] === '.') {
        continue;
      } else {
        url3.push(url1[i]);
      }
    }
    for (let i = 0, l = url2.length; i < l; i++) {
      if (url2[i] === '..') {
        url3.pop();
      } else if (url2[i] === '.') {
        continue;
      } else {
        url3.push(url2[i]);
      }
    }
    return url3.join('/');
  }

  /*
   * Procura o número existente de caracteres em determinada string
   * Atenção: e CASE SENSITIVE, ou seja a é diferente de A
   * @param _str
   * @param _caracter
   * @return
   *
   */
  ContarNumeroDoCaracteresNaString(str: string, caracter: string): number {
    try {
      const numChars: number = str.length;
      let contador = 0;
      for (let i = 0; i < numChars; i++) {
        const item: string = str.charAt(i);
        if (item === caracter) {
          contador++;
        }
      }
      return contador;
    } catch (error: any) {
      console.log(this.constructor.name, 'ContarNumeroDoCarateresNaString', error.message);
    }
  }

  // Checa se é um número
  isNumeric(n: any): boolean {
    try {
      return !isNaN(parseFloat(n)) && isFinite(n);
    } catch (error: any) { }
    return false;
  }

  // Se não for um número, acrescentará aspas.
  quoteIfIsNaN(str): string {
    try {
      if (this.IsNullOrEmpty(str)) {
        return '\'\'';
      } else if (this.isNumeric(str)) {
        return str;
      } else {
        return this.AcrescentarAspas(str);
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'quoteIfIsNaN', error.message);
    }
  }

  /*
   * Checa se TODOS os caracteres da _formula são ou um operador matemático, ou um número.
   * Para considerar como válida a existencia do simbolo # que é usado para as variáveis do GE.
   * @param _formula
   * @return
   *
   */
  IsNumericOrMathSimbol(formula: string, includeVarSeparator: boolean = false): boolean {
    try {
      const numChars: number = formula.length;
      for (let i = 0; i < numChars; i++) {
        const item: string = formula.charAt(i);
        if (includeVarSeparator) {
          this.arrayMathSimbol.push('#');
        }
        if (
          this.arrayMathSimbol.indexOf(item) < 0 && // Não é um operador matemático
          this.arrayOfNumbers.indexOf(item) < 0
        ) {
          // Nem um número
          return false;
        }
      }
      return true;
    } catch (error: any) {
      console.log(this.constructor.name, 'IsNumericOrMathSimbol', error.message);
    }
  }

  /* Checa se tem pelo menos um símbolo matemático, o que é necessário para que seja considerado um cálculo. */
  hasMathSymbol(formula: string): boolean {
    try {
      let has = false;
      this.arrayOperatorMathSimbol.every((e) => {
        if (formula.includes(e)) {
          has = true;
          return false;
        } else {
          return true;
        }
      });
      return has;
    } catch (error: any) {
      console.log(this.constructor.name, 'hasMathSymbol', error.message);
    }
    return false;
  }

  /* Checa se o objeto é um valor ou expressão booleana. */
  isBoolean(obj: any): boolean {
    try {
      return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
    } catch (error: any) {
      console.log(this.constructor.name, 'isBoolean', error.message);
    }
    return false;
  }

  /* Cria um hash a partir de uma string. */
  hashFromString(str: string): number {
    try {
      let hash = 0;
      let i: number;
      let chr: number;
      if (str.length === 0) {
        return hash;
      }

      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    } catch (error: any) {
      console.log(this.constructor.name, 'hashFromString', error.message);
    }
    return -1;
  }

  /*
   *Checa se o array é nulo ou tem zero elementos
   * @param _array
   * @return
   *
   */
  IsArrayNullOrEmpty(array: any[]): boolean {
    try {
      if (array == null) {
        return true;
      } else {
        return array.length <= 0;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'IsArrayNullOrEmpty', error.message);
    }
  }

  /*Se for um único item, ou se já for um array, retornará um array.
   * Útil quando se deseja garantir que o retorno é um array, mas às vezes apresenta único elemento ou vazio.
   */
  alwaysReturnArray(itemOuArray: any): any[] {
    try {
      return [].concat(itemOuArray || []);
    } catch (error: any) {
      console.log(this.constructor.name, 'alwaysReturnArray', error.message);
    }
    return [];
  }

  /* Checa se um objeto é do tipo Array. */
  isArray(obj: any): boolean {
    try {
      if (!Array.isArray) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      }
      return obj.isArray;
    } catch (error: any) {
      console.log(this.constructor.name, 'isArray', error.message);
    }
    return false;
  }

  Distinct(array: any[]): any[] {
    try {
      if (!array) {
        return null;
      }
      array.sort();
      for (let i: number = array.length - 1; i > 0; --i) {
        if (array[i] === array[i - 1]) {
          array.splice(i, 1);
        }
      }
    } catch (error: any) { }
    return array;
  }

  /** Return just the distinct objects comparing a given property. */
  distinctBy<T>(lst: T[], propName: string): T[] {
    try {
      return lst.reduce((a, b) => {
        if (a.findIndex(f => this.isEqual(f[propName], b[propName])) < 0) {
          a.push(b);
        }
        return a;
      }, []);
    } catch (error: any) {
      console.log(this.constructor.name, 'distinctBy', error.message);
    }
    return null;
  }

  /*
   * Checa se a tecla é letra ou número (alfanumérica)
   * @param _keyCode
   * @return
   *
   */
  IsKeyAlphanumeric(keyCode: number): boolean {
    try {
      return keyCode >= 48 && keyCode <= 90;
    } catch (error: any) {
      console.log(this.constructor.name, 'IsKeyAlphanumeric', error.message);
    }
  }

  /*
   * Remove todos os caracteres do tipo fornecido
   * @param str string que pode conter o caracter
   * @param fnd caracter a ser removido
   * @return
   *
   */
  RemoveAll(str: string, fnd: string): string {
    try {
      if (this.IsNullOrEmpty(str)) {
        return str;
      }
      return str.toString().split(fnd).join('');
    } catch (error: any) {
      console.log(this.constructor.name, 'RemoveAll', error.message);
    }
  }

  /*
   * Substitui todos os caracteres do tipo fornecido
   * @param str string que pode conter o caracter
   * @param fnd caracter a ser substituído
   * @param rpl string a substituir o caracter encontrado
   * @return
   *
   */
  ReplaceAll(str: string, fnd: string, rpl: string): string {
    try {
      if (!this.IsNullOrEmpty(str)) {
        return str.toString().split(fnd).join(rpl);
      }
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'ReplaceAll', error.message);
    }
  }

  /*
   * Retorna o último caractere de uma string
   * @param _string
   * @return
   *
   */
  GetLastChar(str: string): string {
    try {
      const str2: string = str.substr(str.length - 1);
      return str2;
    } catch (error: any) {
      console.log(this.constructor.name, 'GetLastChar', error.message);
    }
  }

  /*
   * Retorna o primeiro caractere de uma string
   * @param _string
   * @return
   *
   */
  GetFirstChar(str: string): string {
    try {
      return str.substring(0, 1);
    } catch (error: any) {
      console.log(this.constructor.name, 'GetFirstChar', error.message);
    }
  }

  /*
   *Remove os espaços antes e depois (início e fim da string).
   * @param s
   * @return
   *
   */
  trim(s: string): string {
    try {
      if (this.IsNullOrEmptyGE(s)) {
        return '';
      }
      return s.toString().replace(/^([\s|\t|\n]+)?(.*)([\s|\t|\n]+)?$/gm, '$2');
    } catch (error: any) {
      console.log(this.constructor.name, 'trim', error.message);
    }
  }

  /*
   * Converte uma hora hh:MM em inteiros minutos
   * @param hhMM
   * @return
   *
   */
  toMinute(hhMM: string): number {
    try {
      let signal = 1;
      const menos = '-';
      hhMM = this.RemoveAll(hhMM, '"');
      // A hora pode conter separador de milhar
      hhMM = this.RemoveAll(hhMM, '.');
      hhMM = this.RemoveAll(hhMM, ',');
      if (hhMM.indexOf(menos) >= 0) {
        // Por que o sinal negativo pode chegar no final da expressão
        const count: number = this.CountChar(hhMM, menos);
        hhMM = this.RemoveAll(hhMM, menos);
        signal = count % 2 === 0 ? 1 : -1; // Se o número de sinais negativos for par, será 1 senão -1
      }
      const pos: number = hhMM.indexOf(':');
      const h: number = parseInt(this.Left(hhMM, pos), 10);
      const m: number = parseInt(this.Right(hhMM, 2), 10);
      return signal * h * 60 + m * signal;
    } catch (error: any) {
      console.log(this.constructor.name, 'toMinute', error.message);
    }
  } /*;*/

  /*
   *Conta o número de caracteres char presentes em str
   * @param str
   * @param char
   * @return
   *
   */
  CountChar(str: string, char: string): number {
    try {
      // 			let _split:Array = str.split(char);
      // 			return _split.length - 1;
      const pattern: RegExp = new RegExp(char, 'g');
      const matched: any = str.match(pattern);
      return matched ? matched.length : 0;
    } catch (error: any) {
      console.log(this.constructor.name, 'CountChar', error.message);
    }
  }

  /*
   *  Retorna os n últimos caracteres
   * @param str
   * @param count
   * @return
   *
   */
  Right(str: string, count: number = 1): string {
    try {
      const s: number = str.length - count;
      const f: number = str.length;
      return str.toString().substring(s, f);
    } catch (error: any) {
      console.log(this.constructor.name, 'Right', error.message);
    }
  } /*;*/

  // Retorna os n primeiros caracteres
  Left(str: string, count: number = 1): string {
    try {
      return str.toString().substring(0, count);
    } catch (error: any) {
      console.log(this.constructor.name, 'Left', error.message);
    }
  } /*;*/

  /* aceita time no padrão hh:mm ou hh ou h */
  formatTime(time: string, extractDate: boolean = false): string {
    try {
      if (time) {
        if (extractDate) {
          const typed = this.getTypedValue(time)
          if (typed.type === EnTypedValue.Date) {
            const dt = (typed.value as Date);
            time = `${dt.getHours()}:${dt.getMinutes()}`;
          }
        }
        time = time.replace(/horas/g, '').replace(/hs/g, '').replace(/h/g, '');
        const split = time?.split(':');
        return split?.length <= 1 ? `${this.FormatarNumero(parseInt(time, 10))}:00` :
          split?.reduce((a, b) => {
            if (a) {
              b = b ? this.FormatarNumero(parseInt(b, 10)) : '00';
              return `${a}:${b}`;
            }
            return this.FormatarNumero(parseInt(b, 10));
          }, '');
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'formatTime', error.message);
    }
    return time;
  }

  // Pega um número de minutos e retorna uma string no padrão hh:MM
  toHHMM(m: number): string {
    try {
      const h: number = parseInt((m / 60).toString(), 10);
      const min: number = m % 60;
      const strMin: string = '0' + Math.abs(min);
      const strH: string =
        Math.abs(h) <= 9 ? (h >= 0 ? '0' + h.toString() : '-0' + Math.abs(h).toString()) : h.toString();
      return strH + ':' + this.Right(strMin, 2);
    } catch (error: any) {
      console.log(this.constructor.name, 'toHHMM', error.message);
    }
  }

  getHHMM(hhmmOrhhmmss: string): string {
    try {
      let hhmm = hhmmOrhhmmss;
      if (hhmm.indexOf(':') < 0) {
        hhmm = this.Left(hhmm, 2) + ':' + hhmm.substring(2, 4);
      } else {
        hhmm = this.Left(hhmm, 2) + ':' + hhmm.substring(3, 5);
      }
      return hhmm;
    } catch (error: any) {
      console.log(this.constructor.name, 'getHHMM', error.message);
    }
  }

  // Soma várias horas passadas como parâmetro no formato hh:MM
  // tipos: m retorna um inteiro em minutos, s retorna um inteiro
  // em segundos, h retorna um double de horas fracionadas, hhMM retorna string hh:MM
  // Uma ou mais horas pode ser negativa devendo apenas ter o sinal de negativo antes da hora -01:00
  SumHoursHHMM(tipo: string, hours: any[]): any {
    try {
      let hoursEmMin = 0;
      for (const hour of hours) {
        const item: string = hour;
        hoursEmMin += this.toMinute(item);
      }
      switch (tipo.toUpperCase()) {
        case 'M':
          return hoursEmMin;
        case 'S':
          return hoursEmMin * 60;
        case 'H':
          return hoursEmMin / 60;
        default:
        case 'HHMM':
          return this.toHHMM(hoursEmMin);
      }
    } catch (e) { }
    return null;
  }

  // Public Methods:
  /*
   * Atenção: Espera data no formato dd/mm/yyyy.
   * Não pode variar nem as posições, nem o número de caracteres.
   * @param _data
   * @return
   *
   */
  getDia(data: string): number {
    try {
      data = this.RemoverAspas(data);
      return parseInt(data.substr(0, 2), 10);
    } catch (error: any) {
      console.log(this.constructor.name, 'getDia', error.message);
    }
  }

  getHoraHHMM(data: Date): string {
    try {
      const zeroHora: string = data.getHours().toString().length === 1 ? '0' : '';
      const zeroMinuto: string = data.getMinutes().toString().length === 1 ? '0' : '';
      return zeroHora + data.getHours().toString() + ':' + (zeroMinuto + data.getMinutes().toString());
    } catch (error: any) {
      console.log(this.constructor.name, 'getHoraHHMM', error.message);
    }
  }
  getHoraHHMMSS(data: Date): string {
    try {
      const zeroHora: string = data.getHours().toString().length === 1 ? '0' : '';
      const zeroMinuto: string = data.getMinutes().toString().length === 1 ? '0' : '';
      const zeroSegundo: string = data.getSeconds().toString().length === 1 ? '0' : '';
      return (
        zeroHora +
        data.getHours().toString() +
        ':' +
        (zeroMinuto + data.getMinutes().toString()) +
        ':' +
        (zeroSegundo + data.getSeconds().toString())
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'getHoraHHMMSS', error.message);
    }
  }
  getHoraMMSS(data: Date): string {
    try {
      const zeroMinuto: string = data.getMinutes().toString().length === 1 ? '0' : '';
      const zeroSegundo: string = data.getSeconds().toString().length === 1 ? '0' : '';
      return zeroMinuto + data.getMinutes().toString() + ':' + (zeroSegundo + data.getSeconds().toString());
    } catch (error: any) {
      console.log(this.constructor.name, 'getHoraMMSS', error.message);
    }
  }

  /*
   * Pega uma hora no formato hh:MM e retorna apenas a hora como inteiro
   ** também aceita hh
   * @param _hora
   * @return
   *
   */
  getHora(hora: string): number {
    try {
      hora = this.RemoverAspas(hora);
      hora = this.formatTime(hora);
      const pos: string[] = hora.split(':');
      return parseInt(pos[0], 10);
    } catch (error: any) {
      console.log(this.constructor.name, 'getHora', error.message);
    }
    return null;
  }

  /*
   * ega uma hora no formato hh:MM e retorna apenas o minuto como inteiro
   * @param _hora
   * @param _hasSecond indica se há segundos após os minutos
   * @return
   *
   */
  getMinuto(hora: string, hasSecond: boolean = false): number {
    try {
      hora = this.RemoverAspas(hora);
      if (hasSecond) {
        return parseInt(this.Left(this.Right(hora, 5), 2), 10);
      } else {
        return parseInt(this.Right(hora, 2), 10);
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'getMinuto', error.message);
    }
  }

  /*
   * Pega uma hora no formato hh:MM e retorna apenas os segundos como inteiro
   * @param _hora
   * @return
   *
   */
  getSegundo(hora: string): number {
    try {
      hora = this.RemoverAspas(hora);
      return parseInt(this.Right(hora, 2), 10);
    } catch (error: any) {
      console.log(this.constructor.name, 'getSegundo', error.message);
    }
  }

  /*
   * Verifica se é uma hora válida, dentro das 24h no formato HH:MM
   * Se houver aspas ou sinal negativo serão removidos e a hora poderá continuar válida
   * @param _supostaHora
   * @return
   *
   */
  IsHourHHMM(supostaHora: string): boolean {
    try {
      supostaHora = this.RemoveAll(supostaHora, '"');
      supostaHora = this.RemoveAll(supostaHora, '-');
      const pos: number = supostaHora.indexOf(':');
      if (isNaN(Number(this.Left(supostaHora, pos))) || isNaN(Number(this.Right(supostaHora, 2)))) {
        return false;
      }
      const hora: number = this.getHora(supostaHora);
      const minuto: number = this.getMinuto(supostaHora);
      return hora >= 0 && hora <= 23 && (minuto >= 0 && minuto <= 59);
    } catch (e) {
      return false;
    }
  }

  // Verifica se é uma hora válida, dentro das 24h no formato hh:mm:ss
  IsHourHHMMSS(supostaHora: string): boolean {
    try {
      supostaHora = this.RemoveAll(supostaHora, '"');
      supostaHora = this.RemoveAll(supostaHora, '-');
      const hora: number = this.getHora(supostaHora);
      const minuto: number = this.getMinuto(supostaHora, true);
      const segundo: number = this.getSegundo(supostaHora);
      return hora >= 0 && hora <= 23 && (minuto >= 0 && minuto <= 59) && (segundo >= 0 && segundo <= 59);
    } catch (e) {
      return false;
    }
  }

  /*
   * Verifica se é um tempo válido com horas ilimitadas e minutos < 60
   * @param _supostaHora
   * @return
   *
   */
  IsHourHHHMM(supostaHora: string): boolean {
    try {
      supostaHora = this.RemoveAll(supostaHora, '"');
      supostaHora = this.RemoveAll(supostaHora, '-');
      const minuto: number = parseInt(supostaHora.substr(supostaHora.indexOf(':') + 1, 2), 10);
      return minuto >= 0 && minuto <= 59;
    } catch (e) {
      return false;
    }
  }

  // Retorna a HHMM máxima no formato hhmm
  MAXHOUR(hhMM: any[]): string {
    try {
      const arrayMinutes: any[] = this.ARRAYMINUTES(hhMM);
      const maxHour: number = arrayMinutes.pop();
      return this.toHHMM(maxHour);
    } catch (error: any) {
      console.log(this.constructor.name, 'MAXHOUR', error.message);
    }
  }

  /*
   * Retorna a HHMM mínima no formato hhmm
   * @param _hhMM
   * @return
   *
   */
  MINHOUR(hhMM: any[]): string {
    try {
      const arrayMinutes: any[] = this.ARRAYMINUTES(hhMM);
      const minHour: number = arrayMinutes[0];
      return this.toHHMM(minHour);
    } catch (error: any) {
      console.log(this.constructor.name, 'MINHOUR', error.message);
    }
  }

  // Recebe um array de elementos no formato hh:MM e retorna um array ordenado de forma crescente dos itens convertidos em minutos (int)
  ARRAYMINUTES(hhMM: any[]): any[] {
    try {
      const arrayMinutes: any[] = new Array();
      for (const item of hhMM) {
        if (this.IsHourHHHMM(item)) {
          arrayMinutes.push(parseInt(this.toMinute(item).toString(), 10));
        }
      }
      return arrayMinutes.sort((a: any, b: any) => parseFloat(a) - parseFloat(b));
    } catch (error: any) {
      console.log(this.constructor.name, 'ARRAYMINUTES', error.message);
    }
  }

  /*
   * Calcula o número de horas extra
   * @param _tipo: define o tipo de retorno pode ser HHMM, h para hora fracionada, m para minutos
   * @param _hhMMTempoExpediente: Tempo total do expediente oficial diário a ser
   * cumprido// ATENÇÃO: Se _permitirCompensacao = false esse parâmetro deverá conter o
   * horário de saída do expediente e não o tempo total de expediente
   * @param _hhMMTempoTolerancia: Tempo de tolerância quanto a entrada e/ou saída
   * @param _hhMMTempoRegistradoAlmoco: Tempo total registrado pelo funcionário como almoço
   * @param _hhMMTempoRegistradoEntrada: Hora registrada pelo funcionário de entrada
   * @param _hhMMTempoRegistradoSaida: Hora registrada pelo funcionário de saída
   * @param _permitirCompensacao: Indica se é permitido o regime de Compensação.
   * Se for permitido as horas de atraso "compensam" as horas após o expediente.
   * Sem Compensação registra tanto a falta quanto horas extras.
   * @return
   *
   */
  OVERTIME(
    tipo: string,
    hhMMTempoRegistradoSaida: string,
    hhMMTempoRegistradoEntrada: string,
    hhMMTempoExpediente: string,
    hhMMTempoTolerancia: string,
    hhMMTempoRegistradoAlmoco: string,
    permitirCompensacao: boolean
  ): any {
    try {
      const saidaMin: number = this.toMinute(hhMMTempoRegistradoSaida);
      const entradaMin: number = this.toMinute(hhMMTempoRegistradoEntrada);
      const expedienteMin: number = this.toMinute(hhMMTempoExpediente);
      const toleranciaMin: number = this.toMinute(hhMMTempoTolerancia);
      const almocoMin: number = this.toMinute(hhMMTempoRegistradoAlmoco);
      let overTimeMin: number;
      if (permitirCompensacao) {
        // Exemplo: Com Compensação se chegar 15 min após o horário de entrada,
        // acima da tolerância, não descontará as horas se ficar também 15 min após o expediente
        overTimeMin = saidaMin - entradaMin - expedienteMin - almocoMin;
      } else {
        // Exemplo: Sem Compensação qualquer minuto após o expediente acima da
        // tolerância é considerado como hora extra, independente de ter chegado
        // atrasado (o atraso também deverá ser descontado nesse regime)
        overTimeMin = saidaMin - expedienteMin;
      }
      const overTimeMinTol: number = overTimeMin > toleranciaMin ? overTimeMin : 0;
      return this.retornarFormatoConformeTipo(tipo, overTimeMinTol);
    } catch (error: any) {
      console.log(this.constructor.name, 'OVERTIME', error.message);
    }
  }

  /*
   * Calcula o número de horas falta
   * @param _tipo: define o tipo de retorno pode ser HHMM, h para hora fracionada, m para minutos
   * @param _hhMMTempoExpediente: Tempo total do expediente oficial diário a
   * ser cumprido// ATENÇÃO: Se _permitirCompensacao = false esse parâmetro deverá
   * conter o horário de entrada do expediente e não o tempo total de expediente
   * @param _hhMMTempoTolerancia: Tempo de tolerância quanto a entrada e/ou saída
   * @param _hhMMTempoRegistradoAlmoco: Tempo total registrado pelo funcionário como almoço
   * @param _hhMMTempoRegistradoEntrada: Hora registrada pelo funcionário de entrada
   * @param _hhMMTempoRegistradoSaida: Hora registrada pelo funcionário de saída
   * @param _permitirCompensacao: Indica se é permitido o regime de Compensação.
   *  Se for permitido as horas de atraso "compensam" as horas após o expediente.
   * Sem Compensação registra tanto a falta quanto horas extras.
   * @return
   *
   */
  ABSENT(
    tipo: string,
    hhMMTempoRegistradoSaida: string,
    hhMMTempoRegistradoEntrada: string,
    hhMMTempoExpediente: string,
    hhMMTempoTolerancia: string,
    hhMMTempoRegistradoAlmoco: string,
    permitirCompensacao: boolean
  ): any {
    try {
      const saidaMin: number = this.toMinute(hhMMTempoRegistradoSaida);
      const entradaMin: number = this.toMinute(hhMMTempoRegistradoEntrada);
      const expedienteMin: number = this.toMinute(hhMMTempoExpediente);
      const toleranciaMin: number = this.toMinute(hhMMTempoTolerancia);
      const almocoMin: number = this.toMinute(hhMMTempoRegistradoAlmoco);
      const horasTrabalhadas: number = saidaMin - entradaMin - almocoMin;
      let horasFalta: number;
      if (permitirCompensacao) {
        // Exemplo: Com Compensação se chegar 15 min após o horário de entrada,
        // acima da tolerância, não descontará as horas se ficar também 15 min após o expediente
        horasFalta = horasTrabalhadas >= expedienteMin ? 0 : expedienteMin - horasTrabalhadas;
      } else {
        // Exemplo: Sem Compensação qualquer minuto após o expediente acima
        // da tolerância é considerado como hora extra, independente de ter
        // chegado atrasado (o atraso também deverá ser descontado nesse regime)
        horasFalta = entradaMin - expedienteMin;
      }
      const horasFaltaTol: number = horasFalta > toleranciaMin ? horasFalta : 0;
      return this.retornarFormatoConformeTipo(tipo, horasFaltaTol);
    } catch (error: any) {
      console.log(this.constructor.name, 'ABSENT', error.message);
    }
  }

  /*
   * Calcula o número de horas para cálculo de adicional noturno
   * @param _tipo: define o tipo de retorno pode ser HHMM, h para hora fracionada, m para minutos
   * @param _hhMMTempoRegistradoSaida: Hora registrada pelo funcionário de saída
   * @param _hhMMHoraInicioAdicionalNoturno: Contabilizar como adicional noturno a partir deste horário
   * @return
   *
   */
  NIGHTHOUR(tipo: string, hhMMTempoRegistradoSaida: string, hhMMHoraInicioAdicionalNoturno: string): any {
    try {
      const saidaMin: number = this.toMinute(hhMMTempoRegistradoSaida);
      const inicioAdicionalNoturno: number = this.toMinute(hhMMHoraInicioAdicionalNoturno);
      const horasNoturnas: number =
        saidaMin >= inicioAdicionalNoturno ? saidaMin - inicioAdicionalNoturno : 0;
      return this.retornarFormatoConformeTipo(tipo, horasNoturnas);
    } catch (error: any) {
      console.log(this.constructor.name, 'NIGHTHOUR', error.message);
    }
  }

  getShift(timeHHMM: string): EnShift {
    const { hour, minute } = timeHHMM.split(':')
      .map((item) => parseInt(item, 10))
      .reduce((acc, item, index) => {
        if (index === 0) {
          acc.hour = item;
        } else {
          acc.minute = item;
        }
        return acc;
      }, { hour: 0, minute: 0 });

    if (hour >= 7 && hour < 13) {
      return EnShift.morning;
    } else if (hour >= 13 && hour < 19) {
      return EnShift.afternoon;
    } else {
      return EnShift.night;
    }
  }

  getShiftByDate(date: Date): EnShift {
    const hour = date.getHours();
    const minute = date.getMinutes();

    if (hour >= 7 && hour < 13) {
      return EnShift.morning;
    } else if (hour >= 13 && hour < 19) {
      return EnShift.afternoon;
    } else {
      return EnShift.night;
    }
  }

  protected retornarFormatoConformeTipo(tipo: string, tempoMinutos: number): any {
    try {
      switch (tipo.toUpperCase()) {
        case 'M':
          return tempoMinutos;
        case 'S':
          return tempoMinutos * 60;
        case 'H':
          return tempoMinutos / 60;
        default:
        case 'HHMM':
          return this.toHHMM(tempoMinutos);
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'retornarFormatoConformeTipo', error.message);
    }
  }

  // Formata um número no padrão 01, 02, 10, etc.. Ou seja, com dois dígitos.
  FormatarNumero(numero: number): string {
    try {
      return String('0' + numero).substr(String(numero).length - 1, 2);
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatarNumero', error.message);
    }
  }

  FormatarHora(numeroHora: number): string {
    try {
      if (isNaN(numeroHora) || numeroHora === 0) {
        return '00:00';
      } else {
        let hora: number;
        let minuto: number;
        if (Math.abs(numeroHora) >= 1) {
          hora = Math.round(numeroHora - 0.5);
          minuto = numeroHora % hora;
        } else {
          hora = 0;
          minuto = numeroHora;
        }
        minuto = Math.round(minuto * 60);
        const final = ''; // _minuto == 0 ? "h" : "";
        return (
          String('0' + hora).substr(String(hora).length - 1, 2) +
          ':' +
          String('0' + minuto).substr(String(minuto).length - 1, 2) +
          final
        );
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatarHora', error.message);
    }
  }

  FormatarHHHmmss(numeroHora: number): string {
    try {
      if (isNaN(numeroHora) || numeroHora === 0) {
        return '00:00:00';
      } else {
        const hora: number = Math.round(numeroHora - 0.5);
        let minuto: number = numeroHora % hora;
        let segundo = 0;
        minuto = Math.round(minuto * 60);
        if (minuto >= 60) {
          segundo = minuto - 60;
          minuto -= 60;
        }
        const final = ''; // _minuto == 0 ? "h" : "";
        return (
          String('0' + hora).substr(String(hora).length - 1, String(hora).length) +
          ':' +
          String('0' + minuto).substr(String(minuto).length - 1, 2) +
          ':' +
          String('0' + segundo).substr(String(segundo).length - 1, 2) +
          final
        );
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatarHHHmmss', error.message);
    }
  }

  // Soma duas horas
  // uma das horas pode ser negativa
  // Sintaxe: HOURADD(01:00; -00:30) Resultado 00:30 ou HOURADD(01:00; NOW()) Resultado hora atual + 1 hora
  AddHour(baseHHMM: string, addHHMM: string): string {
    try {
      if (this.IsDateHourDDMMYYYYHHMM(baseHHMM)) {
        baseHHMM = this.FormatDateHour(new Date(baseHHMM), 'hh:mm');
      } else if (this.IsDateHourDDMMYYYYHHMMSS(baseHHMM)) {
        baseHHMM = this.FormatDateHour(new Date(baseHHMM), 'hh:mm');
      }
      if (this.isNumeric(addHHMM)) {
        addHHMM = this.Right('0' + addHHMM, 2) + ':00';
      }
      // Base Hour
      // Não dá para usar o RemoverAspas, pois no caso de número negativo a aspas poderá estar após o sinal -
      baseHHMM = this.RemoveAll(baseHHMM, '"');
      addHHMM = this.RemoveAll(addHHMM, '"');
      const baseArray: any[] = baseHHMM.split(':');
      const baseHour: number = baseArray[0];
      const baseMin: number = baseArray[1];
      let baseHourFrac: number = Math.abs(baseHour) + baseMin / 60;
      baseHourFrac = baseHour < 0 ? baseHourFrac * -1 : baseHourFrac; // Para considerar horas negativas
      // Add Hour
      const addArray: any[] = addHHMM.split(':');
      const addHour: number = addArray[0];
      const addMin: number = addArray[1];
      let addHourFrac: number = Math.abs(addHour) + addMin / 60;
      addHourFrac = addHour < 0 ? addHourFrac * -1 : addHourFrac; // Para considerar horas negativas
      // Soma
      const totalHourFrac: number = baseHourFrac + addHourFrac;
      const strTotal: string = isNaN(totalHourFrac) ? '00:00' : this.FormatarHora(totalHourFrac);
      return strTotal;
    } catch (error: any) {
      console.log(this.constructor.name, 'AddHour', error.message);
    }
  }

  // Atenção: _secToAdd nunca deverá ser maior que 60
  AddSeconds(hhhMMss: string, secToAdd: number): string {
    try {
      const arrHora: any[] = hhhMMss.split(':');
      let hora: number = parseInt(arrHora[0], 10);
      let min: number = parseInt(arrHora[1], 10);
      let sec: number = parseInt(arrHora[2], 10);
      sec = sec + secToAdd;
      if (sec >= 60) {
        sec = sec - 60;
        min++;
        if (min >= 60) {
          min = 0;
          hora++;
        }
      }
      let strHora: string;
      strHora =
        String('0' + hora).substr(String(hora).length - 1, 2) +
        ':' +
        String('0' + min).substr(String(min).length - 4, 2) +
        ':' +
        String('0' + sec).substr(String(sec).length - 1, 2);
      return strHora;
    } catch (error: any) {
      console.log(this.constructor.name, 'AddSeconds', error.message);
    }
  }

  /**
   * Retornar o dia da semana em texto português
   * Domingo = 0 (padrão do AS3)
   * @param _day
   * @return
   */
  DiaDaSemana(day: number): string {
    try {
      if (day >= 0 && day <= 6) {
        const semana: any[] = [
          'Domingo',
          'Segunda-feira',
          'Terça-feira',
          'Quarta-feira',
          'Quinta-feira',
          'Sexta-feira',
          'Sábado'
        ];
        return semana[day];
      } else {
        return 'Dia inválido!';
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'DiaDaSemana', error.message);
    }
  }

  NomeDoMes(date: Date, abreviado: boolean = false): string {
    const mt = date.getMonth();
    if (abreviado) {
      return this.arrayOfMonthsAbrevPtBr[mt];
    } else {
      return this.arrayOfMonthsPtBr[mt];
    }
  }

  /* Checa se é um objeto do tipo date, utilizando javascript puro. */
  isValidDate(date: any): boolean {
    try {
      return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
    } catch (error: any) {
      console.log(this.constructor.name, 'isValidDate', error.message);
    }
    return false;
  }

  /*Checa se é uma data válida
  //deve ser um campo no formato data
  //ou uma string do tipo dd/mm/yyyy ou YYYY-MM-dd hh:mm:ss ou YYYY-MM-dd hh:mm:ss.mmm */
  IsDate(supostaData: any): boolean {
    try {
      if (this.isNullOrEmpty(supostaData)) {
        return false;
      }

      return this.getTypedValue(supostaData).type === EnTypedValue.Date;
    } catch (error: any) {
      console.log(this.constructor.name, 'IsDate', error.message);
    }
    return false;
  }

  /**
   * Converte uma sequencia de horários num array de hh:mm
   * possíveis entradas: 8h, 12, 12h30, 14:00, 16horas, 20hr
   */
  convertHorariosToList(strHorarios: string): string[] {
    try {
      if (!strHorarios) {
        return null;
      }

      const regex = /(\d{1,2}(horas|hs|hrs|hr|h)\d{1,2}(minutos|mins|min|mn|ms|m)?)/gi;
      const matches = regex.exec(strHorarios);
      matches?.filter(f => f)?.forEach(e => {
        strHorarios = strHorarios?.replace(e, e?.replace(/(horas|hora|minutos|mins|min|mn|ms|m|hs|hrs|hr|h)/gi, ':'));
      });
      strHorarios = strHorarios.replace(/(\s|horas|hora|mins|min|m|hs|hrs|hr|h)/gi, '');
      const separator = strHorarios.indexOf(',') >= 0 ? ',' : ';';
      const horarios = strHorarios.split(separator);
      const mapped = horarios?.map(m => {
        const splitted = m.split(':');
        const hour = +splitted[0];
        const min = splitted.length > 1 ? +splitted[1] : 0;
        const time = hour + min / 60;
        return this.FormatarHora(time);
      })

      return mapped;
    } catch (error: any) {
      console.log(this.constructor.name, 'convertHorariosToGrid', error.message);
    }
    return null;
  }

  /* Se não houver uma pontuação no final (. ? ou !), adiciona. */
  addPontoFinal(str: string, pontuacao: string = '.'): string {
    try {
      return str.endsWith('.') || str.endsWith('!') || str.endsWith('?') ? str : `${str}${pontuacao}`;
    } catch (error: any) {
      console.log(this.constructor.name, 'addPontoFinal', error.message);
    }
    return str;
  }

  /* Irá retornar um dos valores fornecidos, o primeiro que for válido. */
  getSomeNumber(invalidToCheck: string = '-1', ...args: any[]): number {
    try {
      let res = null;
      args.some(e => {
        if (!this.isNullOrEmpty(e) && e.toString() !== invalidToCheck) {
          res = this.getTypedValue(e).value;
          return true;
        }
      });
      return res;
    } catch (error: any) {
      console.log(this.constructor.name, 'getSome', error.message);
    }
    return null;
  }

  /**
   * Identifica o tipo do dado e retorna o tipo, uma string e o valor transformado no tipo.
   * location é utilizado para saber o padrão que o dado entra na função, por exemplo,
   * se for pt-br o value de uma data deveria chegar como DDMMYYYY ao invés de MMDDYYYY e
   * um número XX,XX ao invés de XX.XX
   */
  getTypedValue(
    value: any,
    locationInput: string = 'en-US',
    locationOutput: string = 'pt-BR',
    minimumFractionDigits: number = 2
  ): ITypedValue {
    try {
      const nullObj = { type: EnTypedValue.Null, value: null, string: null } as ITypedValue;
      if (value && value !== undefined && Array.isArray(value)) {
        value = value[0];
      }
      if (this.isNullOrEmpty(value)) {
        return nullObj;
      }

      if (this.isValidDate(value)) {
        return {
          type: EnTypedValue.Date,
          string: this.dateToddMMYYYYhhmmss(value),
          value
        } as ITypedValue;
      }

      const pattern_YYYYMMDDThhmmss_sssZ = /^\d{4}(\/|\-)\d{1,2}(\/|\-)\d{1,2}(.|\s)\d{1,2}:\d{1,2}:\d{1,2}.?(\d{3})?Z$/; // 2017-12-06T02:00:00.000Z  Mon Dec 04 2017 00:00:00 GMT-0200 (-02)
      const pattern_YYYYMMDDThhmmss_ssssssZ = /^\d{4}(\/|\-)\d{1,2}(\/|\-)\d{1,2}(.|\s)\d{1,2}:\d{1,2}:\d{1,2}.?(\d{6})?Z$/; // 2024-03-20T00:00:00.000000Z
      const pattern_wwwMMMDDYYYYhhmmssGMTLOC = /^\w{3} \w{3} \d{1,2} \d{4} \d{1,2}:\d{1,2}:\d{1,2} \w{3}(\+|\-)\d{4}( \(.*\))?( \{\.*\})?/; // "Thu Mar 16 2017 00:00:00 GMT-0300 (BRT)" //	Wed Mar 29 2017 00:00:00 GMT-0300 (Hora oficial do Brasil) Fri Aug 10 2018 00:00:00 GMT-0300 (Horário Padrão de Brasília) // Wed Mar 29 2017 00:00:00 GMT-0300 (-03) {}
      const pattern_DDMMYYYYhhmmss = /^\d{1,2}(\/|\-)\d{1,2}(\/|\-)\d{4}(.|\s)\d{1,2}:\d{1,2}:\d{1,2}.?(\d{3})?$/; // "dd/mm/yyyyT00:00:00 ou dd/mm/yyyyT00:00:00.000"
      const pattern_DDMMYYYY = /^\d{1,2}(\/|\-)\d{1,2}(\/|\-)\d{4}$/; // "dd/mm/yyyy"
      const pattern_MMDDYYYYhhmmssAMPM = /^\d{1,2}(\/|\-)\d{1,2}(\/|\-)\d{4}\s\d{2}\:\d{2}\:\d{2}\s\w{2}$/; // 7/17/2018 12:00:00 AM
      const pattern_MMDDYYYY = /^\d{1,2}(\/|\-)\d{1,2}(\/|\-)\d{4}$/; // "mm/dd/yyyy"
      const pattern_MMDDYYYYThhmmss = /^\d{1,2}(\/|\-)\d{1,2}(\/|\-)\d{4}(.|\s)\d{1,2}:\d{1,2}:\d{1,2}.?(\d{3})?$/; // "mm/dd/yyyyT00:00:00 ou dd/mm/yyyyT00:00:00.000"
      const pattern_YYYYMMDD = /^\d{4}(\/|\-)\d{1,2}(\/|\-)\d{1,2}$/; // "YYYY/MM/DD"
      const pattern_YYYYMMDDhhmmss = /^\d{4}(\/|\-)\d{1,2}(\/|\-)\d{1,2}(.|\s)\d{1,2}:\d{1,2}:\d{1,2}.?(\d{3})?$/; // "yyyy/mm/dd 00:00:00 ou yyyy/mm/ddT00:00:00.000
      const pattern_ptBrNumber = /^(\+|\-)?(d|.){1,20},\d{0,5}$/; // Atenção: esse padrão pode confundir um número en com separador de caracteres 1,000
      const pattern_integer = /^\d+$/; // Atenção: esse padrão pode confundir um número en com separador de caracteres 1,000

      let type;
      let rawValue = value;
      const isReal = value && value.toString().indexOf('R$') >= 0;
      if (isReal) {
        rawValue = this.ReplaceAll(value.toString().replace('R$', ''), '.', '').replace(',', '.');
        type = EnTypedValue.Real;
      } else if (pattern_ptBrNumber.test(value.toString())) {
        // isNumPtBr
        rawValue = this.ReplaceAll(rawValue, '.', '').replace(',', '.');
        type = EnTypedValue.Float;
      } else if (value.toString().indexOf('$') >= 0) {
        // isDollar
        rawValue = value.toString().replace('$', '');
        type = EnTypedValue.Dollar;
      } else if (value.toString().indexOf('%') >= 0) {
        // isPercent
        rawValue = value.toString().replace('%', '');
        if (locationInput === 'pt-BR') {
          rawValue = this.ReplaceAll(rawValue, '.', '').replace(',', '.');
        }
        type = EnTypedValue.Percent;
      }
      if (pattern_integer.test(value)) {
        // Está fora da sequencia de else if, pois, deve ser testado para os tipos moeda, percentual, etc.
        return {
          type: EnTypedValue.Integer,
          string: value.toString(),
          value: parseInt(value, 10)
        } as ITypedValue;
      } else if (this.isNumeric(rawValue)) {
        const numValue = parseFloat(rawValue.toString());
        const numStr = numValue.toLocaleString(locationOutput, {
          minimumFractionDigits,
          maximumFractionDigits: minimumFractionDigits
        });
        if (locationInput === 'pt-BR') {
          if (value.toString().indexOf(',') >= 0) {
            return {
              type: type || EnTypedValue.Float,
              string: numStr,
              value: numValue
            } as ITypedValue;
          } else {
            return {
              type: type || EnTypedValue.Integer,
              string: value.toString(),
              value: parseInt(numValue.toString(), 10)
            } as ITypedValue;
          }
        } else {
          if (!this.isInt(rawValue)) {
            return {
              type: type || EnTypedValue.Float,
              string: numStr,
              value: parseFloat(this.ReplaceAll(rawValue.toString(), ',', ''))
            } as ITypedValue;
          } else {
            return {
              type: type || EnTypedValue.Integer,
              string: value.toString(),
              value: parseInt(rawValue, 10)
            } as ITypedValue;
          }
        }
      } else if (pattern_wwwMMMDDYYYYhhmmssGMTLOC.test(value)) {
        const dt = value.getDate ? value : new Date(value);
        return {
          type: EnTypedValue.Date,
          string: this.FormatDate('DDMMYYYY', dt),
          value: dt
        } as ITypedValue;
      } else if (pattern_DDMMYYYYhhmmss.test(value)) {
        return {
          type: EnTypedValue.Date,
          string: value.toString(),
          value: this.ddMMYYYYThhmmssToDate(value)
        } as ITypedValue;
      } else if (pattern_MMDDYYYYhhmmssAMPM.test(value)) {
        return {
          type: EnTypedValue.Date,
          string: value.toString(),
          value: this.MMddYYYYToDate(value)
        } as ITypedValue;
      } else if (pattern_DDMMYYYY.test(value)) {
        return {
          type: EnTypedValue.Date,
          string: value.toString(),
          value: this.ddMMYYYYToDate(value)
        } as ITypedValue;
      } else if (pattern_DDMMYYYY.test(value)) {
        return {
          type: EnTypedValue.Date,
          string: value.toString(),
          value: new Date(value)
        } as ITypedValue;
      } else if (pattern_DDMMYYYYhhmmss.test(value)) {
        return {
          type: EnTypedValue.Date,
          string: value.toString(),
          value: new Date(value)
        } as ITypedValue;
      } else if (pattern_YYYYMMDD.test(value)) {
        const dt = this.YYYYMMddThhmmssToDate(value);
        return {
          type: EnTypedValue.Date,
          string: this.FormatDate('DDMMYYYY', dt),
          value: dt
        } as ITypedValue;
      } else if (pattern_YYYYMMDDThhmmss_ssssssZ.test(value)) {
        const dt = this.YYYYMMddThhmmssToDate(value);
        return {
          type: EnTypedValue.Date,
          string: this.YYYYMMddThhmmssToDateTimeString(value),
          value: dt
        } as ITypedValue;
      } else if (pattern_YYYYMMDDhhmmss.test(value) || pattern_YYYYMMDDThhmmss_sssZ.test(value)) {
        const dt = this.YYYYMMddThhmmssToDate(value);
        return {
          type: EnTypedValue.Date,
          string: this.YYYYMMddThhmmssToDateTimeString(value),
          value: dt
        } as ITypedValue;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'getTypedValue', error.message);
    }
    return {
      type: EnTypedValue.None,
      string: value ? value.toString() : '',
      value
    } as ITypedValue;
  }

  /* Verifica se a string é uma data/hora no padrão YYYY-MM-dd hh:mm:ss */
  IsYYYYMMddhhmmss(supostaData: any): boolean {
    try {
      const pattern1 = /^(\d{4})\-(\d{2})\-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/;
      const pattern2 = /^(\d{4})\-(\d{2})\-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3}).$/;
      return pattern1.test(supostaData) || pattern2.test(supostaData);
    } catch (error: any) {
      console.log(this.constructor.name, 'IsYYYYMMddhhmmss', error.message);
    }
    return false;
  }

  /* Verifica se a string é uma data/hora no padrão YYYY-MM-dd */
  IsYYYYMMdd(supostaData: any): boolean {
    try {
      const pattern1 = /^(\d{4})\-(\d{2})\-(\d{2})$/;
      const pattern2 = /^(\d{4})\-(\d{2})\-(\d{2})$/;
      return pattern1.test(supostaData) || pattern2.test(supostaData);
    } catch (error: any) {
      console.log(this.constructor.name, 'IsYYYYMMdd', error.message);
    }
    return false;
  }

  // Identifica se a datahora no formato dd/MM/yyyy HH:mm:ss é válida
  IsDateHourDDMMYYYYHHMMSS(supostaDataHora: string): boolean {
    try {
      supostaDataHora = this.RemoverAspas(supostaDataHora);
      const date: string = supostaDataHora.substr(0, 10);
      const _hora: string = supostaDataHora.substr(11);
      return this.IsDate(date) && this.IsHourHHMMSS(_hora);
    } catch (error: any) {
      console.log(this.constructor.name, 'IsDateHourDDMMYYYYHHMMSS', error.message);
    }
    return false;
  }

  // Identifica se a datahora no formato dd/MM/yyyy HH:mm:ss é válida
  IsDateHourDDMMYYYYHHMM(supostaDataHora: string): boolean {
    try {
      supostaDataHora = this.RemoverAspas(supostaDataHora);
      const date: string = supostaDataHora.substr(0, 10);
      const hora: string = supostaDataHora.substr(11);
      return this.IsDate(date) && this.IsHourHHMM(hora);
    } catch (error: any) {
      console.log(this.constructor.name, 'IsDateHourDDMMYYYYHHMM', error.message);
    }
    return false;
  }

  // Além de formatar no padrão dd/mm/yyyy corrige o mës que, no as3 é baseado em zero.
  FormatarData(dt: Date): string {
    try {
      if (!dt || dt === undefined) {
        return null;
      }
      const typed = this.getTypedValue(dt);
      const data = typed.value;
      if (typed.type === EnTypedValue.Date) {
        const strMes: string = parseInt((data.getMonth() + 1).toString(), 10).toString();
        const zeroMes: string = strMes.length === 1 ? '0' : '';
        const strDia: string = data.getDate().toString();
        const zeroDia: string = strDia.length === 1 ? '0' : '';
        return zeroDia + strDia + '/' + zeroMes + strMes + '/' + data.getFullYear();
      }
      return null;
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatarData', error.message);
    }
  }

  FormatarDataHora(data: Date, caracterSeparador: string = ' '): string {
    try {
      const zeroMinuto: string = data.getMinutes().toString().length === 1 ? '0' : '';
      const zeroHora: string = data.getHours().toString().length === 1 ? '0' : '';
      const zeroSegundo: string = data.getSeconds().toString().length === 1 ? '0' : '';
      return (
        this.FormatarData(data) +
        caracterSeparador +
        zeroHora +
        data.getHours().toString() +
        ':' +
        zeroMinuto +
        data.getMinutes().toString() +
        ':' +
        zeroSegundo +
        data.getSeconds().toString()
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatarDataHora', error.message);
    }
  }

  GerarData(dia: number, mes: number, ano: number): Date | null {
    try {
      const data: Date = new Date(ano, mes, dia);
      return data;
    } catch (error: any) {
      console.log(this.constructor.name, 'GerarData', error.message);
    }
  }

  MMddYYYYToDate(MMddYYYY: string, arrSeparator: string[] = ['/', '-']): Date | null {
    try {
      if (!MMddYYYY || MMddYYYY === undefined) {
        return null;
      }
      if (typeof MMddYYYY !== 'string') {
        return MMddYYYY as Date;
      }
      MMddYYYY = this.RemoverAspas(MMddYYYY);
      const separator = this.getDateSeparator(MMddYYYY);
      const dt = MMddYYYY.split(separator);
      const mes = parseInt(dt[0], 10) - 1;
      const dia = parseInt(dt[1], 10);
      const ano = parseInt(this.Left(dt[2], 4), 10);
      return new Date(ano, mes, dia);
    } catch (error: any) {
      console.log(this.constructor.name, 'MMddYYYYToDate', error.message);
    }
    return null;
  }

  ddMMYYYYToDate(ddMMYYYY: any, arrSeparator: string[] = ['/', '-']): Date | null {
    try {
      if (!ddMMYYYY || ddMMYYYY === undefined) {
        return null;
      }
      if (typeof ddMMYYYY !== 'string') {
        return ddMMYYYY as Date;
      }
      ddMMYYYY = this.RemoverAspas(ddMMYYYY);
      const separator = this.getDateSeparator(ddMMYYYY);
      const dt = ddMMYYYY.split(separator);
      const dia = dt[0];
      const mes = dt[1] - 1;
      const ano = dt[2];

      return new Date(ano, mes, dia);
    } catch (error: any) {
      console.log(this.constructor.name, 'ddMMYYYYToDate', error.message);
    }
  }

  /* Retorna o separador de datas da string. */
  protected getDateSeparator(dtString: any): string {
    try {
      const str = dtString.toString();
      const arrSeparator: string[] = ['/', '-'];
      let separator = '/';
      arrSeparator.every((e) => {
        if (str.indexOf(e) >= 0) {
          separator = e;
          return false;
        }
        return true;
      });
      return separator;
    } catch (error: any) {
      console.log(this.constructor.name, 'getDateSeparator', error.message);
    }
    return '/';
  }

  isDate(date: any): boolean {
    try {
      return date instanceof Date && !isNaN(date.valueOf());
    } catch (error: any) {
      console.log(this.constructor.name, 'isDate', error.message);
    }
    return false;
  }

  /**
   * Converte uma string de data no padrão dd/MM/YYYYThh:mm:ss para um Date.
   * A separação entre data e hora podem ser espaço em branco ou T.
   * A separação entre os elementos da data pode ser / ou -.
   */
  ddMMYYYYThhmmssToDate(ddMMYYYY: any): Date | null {
    try {
      if (!ddMMYYYY || ddMMYYYY === null || ddMMYYYY === undefined) {
        return null;
      }
      if (this.isDate(ddMMYYYY)) {
        return ddMMYYYY;
      }
      ddMMYYYY = this.RemoverAspas(ddMMYYYY);
      const split = ddMMYYYY.indexOf('T') >= 0 ? ddMMYYYY.split('T') : ddMMYYYY.split(' ');
      const dt = ddMMYYYY.indexOf('/') >= 0 ? split[0].split('/') : split[0].split('-');
      const hr = split[1] ? split[1].split(':') : ['00', '00', '00'];
      const dia = dt[0];
      const mes = dt[1] - 1;
      const ano = dt[2];
      const hora = hr[0];
      const minuto = hr[1];
      const segundo = hr[2];

      return new Date(ano, mes, dia, hora, minuto, segundo);
    } catch (error: any) {
      console.log(this.constructor.name, 'ddMMYYYYThhmmssToDate', error.message);
    }
  }

  /**
   * Data proveniente do webservice tipo Date do .net
   * Converte uma string de data no padrão YYYY/MM/ddThh:mm:ss para um Date.
   * A separação entre data e hora podem ser espaço em branco ou T.
   * A separação entre os elementos da data pode ser / ou -.
   */
  YYYYMMddThhmmssToDate(YYYYMMddThhmmssToDate: any, retornarDataHojeSeNull: boolean = false): Date | any {
    try {

      if (!YYYYMMddThhmmssToDate || YYYYMMddThhmmssToDate === undefined) {
        return null;
      }
      YYYYMMddThhmmssToDate = this.RemoverAspas(YYYYMMddThhmmssToDate);
      const split =
        YYYYMMddThhmmssToDate.indexOf('T') >= 0
          ? YYYYMMddThhmmssToDate.split('T')
          : YYYYMMddThhmmssToDate.split(' ');
      const dt = YYYYMMddThhmmssToDate.indexOf('/') >= 0 ? split[0].split('/') : split[0].split('-');
      const ano = dt[0];
      const mes = dt[1] - 1;
      const dia = dt[2];
      let date;

      if (split.length === 2) {
        const hr = split[1].split(':');
        const hora = hr[0];
        const minuto = hr[1];
        const segundo = +this.getLeft(hr[2], 2); // Necessário pois o último item pode ser 00.000Z
        date = new Date(ano, mes, dia, hora, minuto, segundo);
      } else {
        date = new Date(ano, mes, dia);
      }

      // return new Date(date.getTime() - 3 * 60 * 60 * 1000);
      return date;
    } catch (error: any) {
      console.log(this.constructor.name, 'YYYYMMddThhmmssToDate', error.message);
    }

    return YYYYMMddThhmmssToDate;
  }

  /// Data proveniente do webservice tipo Date do .net
  YYYYMMddThhmmssToDateTimeString(YYYYMMddThhmmssToDate: string): string {
    try {
      YYYYMMddThhmmssToDate = this.RemoverAspas(YYYYMMddThhmmssToDate);
      return this.FormatarDataHora(this.YYYYMMddThhmmssToDate(YYYYMMddThhmmssToDate));
    } catch (error: any) {
      console.log(this.constructor.name, 'YYYYMMddThhmmssToDateTimeString', error.message);
    }
    return YYYYMMddThhmmssToDate;
  }

  now(): Date {
    const td = new Date();
    return new Date(td.getFullYear(), td.getMonth(), td.getDate());
  }

  today(): Date {
    const td = new Date();
    return new Date(td.getFullYear(), td.getMonth(), td.getDate(), 0, 0, 0);
  }

  tomorrow(): Date {
    const td = new Date();
    return new Date(td.getFullYear(), td.getMonth(), td.getDate() + 1, 0, 0, 0);
  }

  yesterday(): Date {
    const td = new Date();
    return new Date(td.getFullYear(), td.getMonth(), td.getDate() - 1, 0, 0, 0);
  }

  /**
   * Atenção: inclui as barras dd/MM/yyyy
   * @param _data
   * @return
   */
  DateToddMMYYYY(data: any): string {
    try {
      if (!this.isValidDate(data)) {
        return data;
      }

      let dia: string = data.getDate().toString();
      let mes: string = (data.getMonth() + 1).toString();
      dia = String('0' + dia).substr(String(dia).length - 1, 2);
      mes = String('0' + mes).substr(String(mes).length - 1, 2);
      return dia + '/' + mes + '/' + data.getFullYear().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'DateToddMMYYYY', error.message);
    }
  }

  /**
   * Atenção: inclui as barras MM/yyyy
   * @param _data
   * @return
   */
  DateToMMYYYY(data: Date): string {
    try {
      let mes: string = (data.getMonth() + 1).toString();
      mes = String('0' + mes).substr(String(mes).length - 1, 2);
      return mes + '/' + data.getFullYear().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'DateToMMYYYY', error.message);
    }
  }

  /**
   * Atenção: inclui as barras dd/MM
   * @param _data
   * @return
   */
  DateToddMM(data: Date): string {
    try {
      let dia: string = data.getDate().toString();
      let mes: string = (data.getMonth() + 1).toString();
      dia = String('0' + dia).substr(String(dia).length - 1, 2);
      mes = String('0' + mes).substr(String(mes).length - 1, 2);
      return dia + '/' + mes;
    } catch (error: any) {
      console.log(this.constructor.name, 'DateToddMM', error.message);
    }
  }

  DateToMMddYYYY(data: Date): string {
    try {
      if (!data || !this.isDate(data)) {
        return null;
      }

      let dia: string = data.getDate().toString();
      let mes: string = (data.getMonth() + 1).toString();
      dia = String('0' + dia).substr(String(dia).length - 1, 2);
      mes = String('0' + mes).substr(String(mes).length - 1, 2);
      return mes + '/' + dia + '/' + data.getFullYear().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'DateToMMddYYYY', error.message);
    }
  }

  DateToYYYYMMdd(data: Date, separator: string = '/'): string {
    try {
      if (this.isDate(data)) {
        let dia: string = data.getDate().toString();
        let mes: string = (data.getMonth() + 1).toString();
        dia = String('0' + dia).substr(String(dia).length - 1, 2);
        mes = String('0' + mes).substr(String(mes).length - 1, 2);
        return data.getFullYear().toString() + separator + mes + separator + dia;
      } else {
        return data as unknown as string;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'DateToYYYYMMdd', error.message);
    }
    return null;
  }

  GetYearsOld(dob: Date): number {
    try {
      if (!this.isDate(dob)) {
        return null;
      }
      const ageDifMs = Date.now() - dob.getTime();
      const ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    } catch (error: any) {
      console.log(this.constructor.name, 'GetYearsOld', error.message);
    }
  }

  /* Compara duas datas numericamente para operações de sort. */
  compareDates(dt1: Date, dt2: Date): number {
    try {
      if (dt1 && !dt2) {
        return 1;
      } else if (!dt1 && dt2) {
        return -1;
      } else if (!dt1 && !dt2) {
        return 1;
      }
      return dt1.getTime() - dt2.getTime();
    } catch (error: any) {
      console.log(this.constructor.name, 'compareDates', error.message);
    }
  }

  dateDiff(date1: Date, date2: Date, key: string = 't'): any {
    try {
      // calculando a diferença em milisegundos das datas
      let sec: number = date2.getTime() - date1.getTime();

      // verificando se a segunda data é inferior que a primeira
      if (sec < 0) {
        // Alert.show("A segunda data deve ser superior a primeira!");
        return 'Data inicial maior que a final';
      }

      // variáveis auxiliares
      const second = 1000;
      const minute: number = 60 * second;
      const hour: number = 60 * minute;
      const day: number = 24 * hour;

      // resultado em horas decimais
      const rdh: number = Math.ceil(sec / hour);
      // resultado em minutos decimais
      const rdm: number = Math.ceil(sec / minute);
      // resultado em segundos
      const rds: number = Math.ceil(sec / second);

      const days: number = Math.floor(sec / day);
      sec -= days * day;
      const hours: number = Math.floor(sec / hour);
      sec -= hours * hour;
      const minutes: number = Math.floor(sec / minute);
      sec -= minutes * minute;
      const seconds: number = Math.floor(sec / second);

      let out: string;
      const minFrac: number = minutes + seconds / 60;
      const hourFrac: number = hours + minFrac / 60;
      const dayFrac: number = days + hourFrac / 24;
      switch (key.toUpperCase()) {
        default:
        case 'T':
          out =
            (days === 0 ? '' : days + ' dia' + (days > 1 ? 's' : '') + ', ') +
            (hours === 0 ? '' : hours + ' hora' + (hours > 1 ? 's' : '') + ', ') +
            (minutes === 0 ? '' : minutes + ' minuto' + (minutes > 1 ? 's' : '') + ', ') +
            (seconds === 0 ? '' : seconds + ' segundo' + (seconds > 1 ? 's' : ''));
          break;
        case 'D':
          out = parseInt(Math.round(dayFrac).toString(), 10).toString();
          break;
        case 'H':
          out = parseInt(Math.round(days * 24 + hourFrac).toString(), 10).toString();
          break;
        case 'M':
          out = parseInt(Math.round(days * 24 * 60 + hours * 60 + minFrac).toString(), 10).toString();
          break;
        case 'S':
          out = parseInt(
            Math.round(days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds).toString(),
            10
          ).toString();
          break;
      }
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        return '0';
      } else {
        if (this.GetLastChar(out) === ' ') {
          out = this.RemoveLastChar(this.RemoveLastChar(out));
        }
        if (this.GetLastChar(out) === ',') {
          out = this.RemoveLastChar(out);
        }
        return out;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'dateDiff', error.message);
    }
  }

  /**
   * Retorna a diferença em dias entre duas datas. Irá desconsiderar
   * os horários, pois, caso contrário, pode dar diferença no arredondamento.
   */
  dateDiffDays(first: Date, second: Date): number {
    try {
      first = this.getDateWithoutHour(first);
      second = this.getDateWithoutHour(second);

      return Math.round((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24));
    } catch (error: any) {
      console.log(this.constructor.name, 'dateDiffDays', error.message);
    }
  }

  /* Retorna um tipo de Data mas com o horário zerado. */
  getDateWithoutHour(date: Date): Date | null {
    try {
      if (!date) {
        return null;
      }

      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } catch (error: any) {
      console.log(this.constructor.name, 'getDateWithoutHour', error.message);
    }
    return null;
  }

  /**
   * Retorna a data do último dia da semana, ou seja, o próximo sábado
   * Se os dias a mais estiver preenchido, retornará a data em x dias após esse sábado
   * @param _dataNaSemana
   * @param _diasAmais
   * @return
   */
  UltimoDiaDaSemana(dataNaSemana: Date, diasAmais: number = 0): Date | null {
    try {
      const diferencaDiasParaProximoSabado: number = 6 - dataNaSemana.getDay();
      return this.DateAdd('d', diasAmais, this.DateAdd('d', diferencaDiasParaProximoSabado, dataNaSemana));
    } catch (error: any) {
      console.log(this.constructor.name, 'UltimoDiaDaSemana', error.message);
    }
  }

  // retorna o Domingo
  PrimeiroDiaDaSemana(dataInicial: Date): Date | null {
    try {
      if (dataInicial.getDay() !== 0) {
        // Domingo
        const deltaParaDomingo: number = 0 - dataInicial.getDay();
        dataInicial = this.DateAdd('d', deltaParaDomingo, dataInicial);
      }
      return dataInicial;
    } catch (error: any) {
      console.log(this.constructor.name, 'PrimeiroDiaDaSemana', error.message);
    }
  }

  /**
   * Retorna um número inteiro que representa o número da semana, no ano, para a data fornecida.
   * Se a primeira semana do ano começar num dia diferente do domingo, essa primeira semana terá dias a menos.
   * O número da primeira semana do ano é 1.
   * @param _date
   * @return
   */
  WeekOfYear(date: Date): number {
    try {
      const firstOfTheYear: Date = new Date(date.getFullYear(), 0, 1);
      const dayOfFirstDay: number = firstOfTheYear.getDay();
      const convertFirstDayToSunday: Date = this.DateAdd('d', -dayOfFirstDay, firstOfTheYear);
      const dayOfYear: number = parseInt(
        ((date.getTime() - convertFirstDayToSunday.getTime()) / 1000 / 60 / 60 / 24).toString(),
        10
      );
      const weekNumber: number = parseInt((dayOfYear / 7 + 1).toString(), 10);
      return weekNumber;
    } catch (error: any) {
      console.log(this.constructor.name, 'WeekOfYear', error.message);
    }
  }

  /**
   * Retorna o último dia do mês extraído por _strDate conforme o _tipoRetorno
   * @param _tipoRetorno "Date" para retornar um tipo Date. "ddMMyyyy"
   * retorna uma data dd/MM/yyyy  "MMddyyyy" para MM/dd/yyyy, "yyyyMMdd" para yyyy-MM-dd, dd apenas o número do dia, MMYYYY para MM/yyyy
   * @param _strDate pode ser uma data, pode ser um número do mês e pode ser a palavra-chave TODAY (para pegar a data do dia)
   * @return
   */
  LastDayOfMonth(tipoRetorno: string, strDate: string): any {
    try {
      if (this.IsNullOrEmptyGE(strDate)) {
        return -1;
      } else {
        let refDate: Date;
        const today: Date = new Date();
        if (strDate.toUpperCase() === 'TODAY') {
          // Palavra-chave TODAY
          refDate = new Date(
            today.getFullYear(),
            today.getMonth(),
            this.getLastDayOfMonth(today.getMonth(), today.getFullYear())
          );
        } else if (this.IsDate(strDate)) {
          // É uma data
          refDate = this.ddMMYYYYToDate(strDate);
          refDate = new Date(
            refDate.getFullYear(),
            refDate.getMonth(),
            this.getLastDayOfMonth(refDate.getMonth(), refDate.getFullYear())
          );
        } else if (!isNaN(parseInt(strDate, 10))) {
          // É um número do mês
          const mes: number = parseInt(strDate, 10) - 1;
          if (mes <= 11 && mes >= 0) {
            refDate = new Date(
              today.getFullYear(),
              mes,
              this.getLastDayOfMonth(mes, today.getFullYear())
            );
          } else {
            return -1;
          }
        }
        if (tipoRetorno.toUpperCase() === 'YYYYMMDD') {
          return this.FormatDate(tipoRetorno, refDate, '-');
        } else if (tipoRetorno.toUpperCase() === 'DATE') {
          return refDate;
        } else {
          return this.FormatDate(tipoRetorno, refDate);
        }
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'LastDayOfMonth', error.message);
    }
    return -1;
  }

  /**
   *Janeiro = 0 . Cuidado pois segue o padrão das funções do AS3 janeiro = 0
   * @param _month
   * @param _year
   * @return
   */
  protected getLastDayOfMonth(month: number, year: number): number {
    try {
      const arrayLastDay: any[] = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (month === 1 && year % 4 === 0) {
        // Teste de ano bissexto. mês 1 corresponde a fevereiro
        return 29;
      } else {
        return arrayLastDay[month];
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'getLastDayOfMonth', error.message);
    }
  }

  /**
   * Permite especificar o formato de retorno de uma data
   * @param _tipo "ddMMyyyy" retorna uma data dd/MM/yyyy
   * "MMddyyyy" para MM/dd/yyyy, "yyyyMMdd" para yyyy-MM-dd,
   * dd apenas o número do dia, MMYYYY para MM/yyyy
   * @param _date
   * @param _separator o default é "/"
   * @return
   */
  protected FormatDate(tipo: string, dt: Date, separator: string = '/'): string {
    try {
      if (!dt || dt === undefined) {
        return null;
      }
      switch (tipo.toUpperCase()) {
        case 'DDMMYYYY':
          return dt.getDate() + separator + (dt.getMonth() + 1) + separator + dt.getFullYear();
        case 'MMDDYYYY':
          return dt.getMonth() + 1 + separator + dt.getDate() + separator + dt.getFullYear();
        case 'YYYYMMDD':
          return dt.getFullYear() + separator + (dt.getMonth() + 1) + separator + dt.getDate();
        case 'MMYYYY':
          return dt.getMonth() + 1 + separator + dt.getFullYear();
        case 'DD':
          return dt.getDate().toString();
      }
      return dt.toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatDate', error.message);
    }
  }

  /**
   * Recebe um array de datas no padrão ddmmyyyy e retorna a maior data
   * @param _ddmmyyyy
   * @return
   */
  MAXDATE(ddmmyyyy: any[]): Date | null {
    try {
      if (ddmmyyyy.length > 0) {
        const dtCrescente: any[] = ddmmyyyy.sort(this.sortByDate);
        return this.ddMMYYYYToDate(dtCrescente.pop());
      }
      return null;
    } catch (error: any) {
      console.log(this.constructor.name, 'MAXDATE', error.message);
    }
  }

  /**
   * Recebe um array de datas no padrão ddmmyyyy e retorna a maior data
   * @param _ddmmyyyy
   * @return
   */
  MINDATE(ddmmyyyy: any[]): Date | null {
    try {
      if (ddmmyyyy.length > 0) {
        const dtCrescente: any[] = ddmmyyyy.sort(this.sortByDate);
        return this.ddMMYYYYToDate(dtCrescente[0]);
      }
      return null;
    } catch (error: any) {
      console.log(this.constructor.name, 'MINDATE', error.message);
    }
  }

  /**
   * Função interna para ser usada como parâmetro de um array.sort para ordenar datas
   * @param a
   * @param b
   * @return
   */
  private sortByDate(a: string, b: string): number {
    try {
      const dta: Date = this.ddMMYYYYToDate(a);
      const dtb: Date = this.ddMMYYYYToDate(b);
      const difference: number = this.truncateDate(dta) - this.truncateDate(dtb);
      return difference / Math.abs(difference);
    } catch (error: any) {
      console.log(this.constructor.name, 'sortByDate', error.message);
    }
  }

  // replace Object with the proper type
  private truncateDate(object: Date): number {
    try {
      const firstReferenceDate: Date = new Date(1970, 0, 1, 0, 0, 0, 0);
      if (object < firstReferenceDate) {
        object = firstReferenceDate;
      }
      return (object as Date).getTime() * 0.0001;
    } catch (error: any) {
      console.log(this.constructor.name, 'truncateDate', error.message);
    }
  }

  /**
   * Oferece várias opções para formatação de uma data válida, conforme parâmetros
   * @param _format
   * dd/mm/yyyy hh:mm:ss
   * dd/mm/yyyy hh:mm
   * dd/mm/yyyy
   * dd/mm
   * d dia do mês numérico
   * D Dia por extenso
   * m número do mês de 1 a 12
   * M mês por extenso
   * h hora
   * m minuto
   * s segundo
   * hh:mm
   * mm:ss
   * y ano numérico
   * w dia da semana de 1 a 7
   * W dia da semana por extenso
   * As combinações são aceitas, e podem ser misturadas com caracteres
   * Exemplo: W ", " d " de " M " de " y  Resultado: segunda-feira, 01 de janeiro de 2015
   * @return
   * OBS: as partes que são strings deve estar entre aspas para que não haja risco de serem substituídas.
   */
  FormatDateHour(dt: Date, format: string): string {
    try {
      const split: any[] = this.RemoverAspas(this.trim(format)).split(this.regexEntreAspas);
      const splitFiltered: any[] = split.filter((item: string, index: number, array: any[]): boolean => {
        return !this.IsNullOrEmpty(item);
      });

      const count: number = splitFiltered.length;

      for (let i = 0; i < count; i++) {
        if (this.Left(splitFiltered[i], 1) !== '"') {
          // Item entre aspas, e não deve ser substituído
          const testCount: number = this.testExpressions.length;
          for (let j = 0; j < testCount; j++) {
            // Testará se o item corresponde a uma formatação válida
            const test: any[] = this.testExpressions[j];
            const strToTest: string = this.RemoveAll(this.trim(splitFiltered[i]), '"');
            if (test[0].test(strToTest.toString())) {
              // Remover aspas e espaços
              splitFiltered[i] = test[1].call(this, dt);
              break;
            }
          }
        }
      }
      return this.RemoveAll(splitFiltered.join(''), '"');
    } catch (error: any) {
      console.log(this.constructor.name, 'FormatDateHour', error.message);
    }
  }

  private func_d(dt: Date): string {
    try {
      const dtStr: string = this.DateToddMMYYYY(dt);
      return this.getDia(dtStr).toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_d', error.message);
    }
  }

  /**
   * Dia da semana por extenso
   * @param _dt
   * @return
   */
  private func_D(dt: Date): string {
    try {
      return this.DiaDaSemana(dt.getDay()).toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_D', error.message);
    }
  }

  private func_m(dt: Date): string {
    try {
      return (dt.getMonth() + 1).toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_m', error.message);
    }
  }

  private func_M(dt: Date): string {
    try {
      return this.arrayOfMonthsPtBr[dt.getMonth()];
    } catch (error: any) {
      console.log(this.constructor.name, 'func_M', error.message);
    }
  }

  private func_h(dt: Date): string {
    try {
      return dt.getHours().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_h', error.message);
    }
  }

  private func_mm(dt: Date): string {
    try {
      return dt.getMinutes().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_mm', error.message);
    }
  }

  private func_s(dt: Date): string {
    try {
      return dt.getSeconds().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_s', error.message);
    }
  }

  private func_y(dt: Date): string {
    try {
      return dt.getFullYear().toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_y', error.message);
    }
  }

  private func_w(dt: Date): string {
    try {
      return (dt.getDay() + 1).toString();
    } catch (error: any) {
      console.log(this.constructor.name, 'func_w', error.message);
    }
  }

  private func_ddmm(dt: Date): string {
    try {
      return this.DateToddMM(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_ddmm', error.message);
    }
  }

  private func_mmyyyy(dt: Date): string {
    try {
      return this.DateToMMYYYY(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_mmyyyy', error.message);
    }
  }

  private func_ddmmyyyy(dt: Date): string {
    try {
      return this.DateToddMMYYYY(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_ddmmyyyy', error.message);
    }
  }

  private func_ddmmyyyyhhmmss(dt: Date): string {
    try {
      return this.DateToddMMYYYY(dt) + ' ' + this.getHoraHHMMSS(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_ddmmyyyyhhmmss', error.message);
    }
  }

  private func_ddmmyyyyhhmm(dt: Date): string {
    try {
      return this.DateToddMMYYYY(dt) + ' ' + this.getHoraHHMM(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_ddmmyyyyhhmm', error.message);
    }
  }

  private func_hhmm(dt: Date): string {
    try {
      return this.getHoraHHMM(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_hhmm', error.message);
    }
  }

  private func_hhmmss(dt: Date): string {
    try {
      return this.getHoraHHMMSS(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_hhmmss', error.message);
    }
  }

  private func_mmss(dt: Date): string {
    try {
      return this.getHoraMMSS(dt);
    } catch (error: any) {
      console.log(this.constructor.name, 'func_mmss', error.message);
    }
  }

  // Retorna uma string no padrão yyyy-mm-dd
  // Também corrige o número do mës que, no Flash, inicia no zero
  RetornarAllXsdDate(dt: any): string {
    try {
      if (this.IsYYYYMMdd(dt)) {
        return dt;
      }
      const strMes: string = parseInt((dt.getMonth() + 1).toString(), 10).toString();
      const str: string =
        dt.getFullYear() +
        '-' +
        ('0' + strMes).substr(String(strMes).length - 1, 2) +
        '-' +
        ('0' + dt.getDate()).substr(String(dt.getDate()).length - 1, 2);
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'RetornarAllXsdDate', error.message);
    }
  }

  RetornarAllXsdDateTime(dt: any): string {
    try {
      if (this.IsYYYYMMddhhmmss(dt)) {
        return dt;
      }
      const strMes: string = parseInt((dt.getMonth() + 1).toString(), 10).toString();
      const strData: string =
        dt.getFullYear() +
        '-' +
        ('0' + strMes).substr(String(strMes).length - 1, 2) +
        '-' +
        ('0' + dt.getDate()).substr(String(dt.getDate()).length - 1, 2);
      const strHora: string =
        ('0' + dt.getHours()).substr(String(dt.getHours()).length - 1, 2) +
        ':' +
        ('0' + dt.getMinutes()).substr(String(dt.getMinutes()).length - 1, 2) +
        ':' +
        ('0' + dt.getSeconds()).substr(String(dt.getSeconds()).length - 1, 2);
      return strData + 'T' + strHora;
    } catch (error: any) {
      console.log(this.constructor.name, 'RetornarAllXsdDateTime', error.message);
    }
  }

  RetornarAllXsdTime(dt: Date): string {
    try {
      const strHora: string =
        ('0' + dt.getHours()).substr(String(dt.getHours()).length - 1, 2) +
        ':' +
        ('0' + dt.getMinutes()).substr(String(dt.getMinutes()).length - 1, 2) +
        ':' +
        ('0' + dt.getSeconds()).substr(String(dt.getSeconds()).length - 1, 2);
      return strHora;
    } catch (error: any) {
      console.log(this.constructor.name, 'RetornarAllXsdTime', error.message);
    }
  }

  ConvertToCData(str: string): string {
    try {
      if (this.IsNullOrEmpty(str)) {
        return '';
      }
      const startCDATA = '<![CDATA[';
      const endCDATA = ']]> ';
      if (str.toString().indexOf(startCDATA) < 0) {
        // Se encontrado, provavelmente indica um xml, necessário tratar, pois, CDATA não permite aninhamento
        str = startCDATA + str + endCDATA; // .replace("]]>", "]>")
      } else {
        str = this.ChecaAspas(str) ? str : this.Quote(str);
      }
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'ConvertToCData', error.message);
    }
  }

  // Fará as limpezas e preparações necessárias para que o conteúdo de uma tag XML seja válido, ou seja, não prejudique o XML
  PrepareToXML(str: string): string {
    try {
      str = this.CleanNonAscII(str);
      str = this.ConvertToCData(str);
    } catch (error: any) {
      console.log('Global', 'PrepareToXML', error.message);
    }
    return str;
  }

  /* Verifica se o parametro é nulo, undefined, vazio, ou mesmo se é um nulo no formato que o xml retorna */
  IsNullOrEmpty(str: any): boolean {
    try {
      if (str === undefined || str === null) {
        return true;
      }
      if (str.$) {
        // Para cobrir os objetos nulos resgatados do XML
        if (str.$.toLocaleString() === '[object Object]') {
          return true;
        }
      }
      return str === null || str.toString() === '';
    } catch (error: any) {
      console.log(this.constructor.name, 'IsNullOrEmpty', error.message);
    }
  }

  /* Verifica se cada um dos parâmetros (values) é diferente de vazio, nulo, ou undefined.
  * Pode receber um conjunto de valores.
  */
  isNotNullOrEmpty(...values: any[]): boolean {
    try {
      return values.reduce((a, b) => a && !this.isNullOrEmpty(b), true);
    } catch (error: any) {
      console.log(this.constructor.name, 'isNullOrEmpty', error.message);
    }
    return false;
  }

  /**
   * Verifica se cada um dos parâmetros (values) é diferente de vazio, nulo, ou undefined.
   * Pode receber um conjunto de valores.
   * Exatamente a mesma coisa que isNotNullOrEmpty, no entanto potencialmente mais claro.
   */
  hasValue(...values: any[]): boolean {
    try {
      return values.reduce((a, b) => a && !this.isNullOrEmpty(b), true);
    } catch (error: any) {
      console.log(this.constructor.name, 'isNullOrEmpty', error.message);
    }
    return false;
  }

  /**
   * Também valida o símbolo de vazio usado no GE #VAZIO#  e "NÃO INFORMADO"
   * @param _str
   * @return
   * _considerIncludeEmpty: se true, irá verificar se uma parte da string contém algum valor nulo ou não informado,
   * pois, as strings concatenadas se comportam dessa forma.
   */
  IsNullOrEmptyGE(
    str: string,
    considerNotInformedAsEmpty: boolean = false,
    considerIncludeEmpty: boolean = false
  ): boolean {
    try {
      if (this.isNullOrEmpty(str)) {
        return true;
      }

      str = str.toString().toUpperCase();
      let isNull = false;
      this.GE_EMPTY_STRINGS.every((e) => {
        if (considerIncludeEmpty) {
          if (str.includes(e.toUpperCase())) {
            isNull = true;
            return false;
          }
        } else {
          if (this.isEqual(str, e)) {
            isNull = true;
            return false;
          }
        }
        return true;
      });
      return isNull;
    } catch (error: any) {
      console.log(this.constructor.name, 'IsNullOrEmptyGE', error.message);
    }
    return false;
  }

  /**
   * Remove todos os caracteres fora da tabela ASCII (exemplo: símbolos de formatação do word)
   * Elimina os caracteres fora dos limites da tabela ASCII e ASCII Extendida.
   * Retorna a string modificada e corrigida
   * A função de retorno é opcional e retorna a lista de caracteres inválidos
  */
  CleanNonAscII(strToClean: string, funcReturnArrayOfInvalid: Function = null): string {
    try {
      let str = '';
      const invalids: any[] = new Array();
      for (let i = 0; i < strToClean.length; i++) {
        if (this.isValidASC(strToClean.charCodeAt(i))) {
          str += strToClean.charAt(i);
        } else {
          const indexSpecial: number = this.ASCII_SPECIAL.indexOf(strToClean.charCodeAt(i));
          if (indexSpecial >= 0) {
            str += this.ASCII_SPECIAL_REPLACE[indexSpecial];
          }
          if (invalids.indexOf(strToClean.charAt(i)) < 0) {
            // Mesmo se substituído, popular a lista de inválidos
            invalids.push(strToClean.charAt(i));
          }
        }
      }
      if (funcReturnArrayOfInvalid != null && invalids.length > 0) {
        funcReturnArrayOfInvalid(invalids);
      }
      return str;
    } catch (error: any) {
      console.log('Global', 'CleanNonAscII', error.message);
    }
    return strToClean;
  }

  // Testa os caracteres fora dos limites da tabela ASCII e ASCII Extendida.
  private isValidASC(charCode: number): boolean {
    try {
      return (
        (charCode >= this.ASCII_START && charCode <= this.ASCII_END) ||
        (charCode >= this.ASCII__EXTENDED_START && charCode <= this.ASCII_EXTENDED_END)
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'isValidASC', error.message);
    }
  }

  /// Extrai o valor da variável, desconsiderado o track armazenado
  // Atenção: Se houvesse ";" após o número de variáveis de track ele conseguirá trazer o conteúdo,
  // mas o ponto-e-vírgula será ignorado.
  extractVariableValue(variable: string): string {
    try {
      const lstVar: any[] = variable.split(';');
      let retorno = '';
      for (const varItem of lstVar) {
        // this.config.ACTIVITY_NUMBER_OF_TRACK_VARIABLE
        retorno += varItem;
      }
      return retorno;
    } catch (error: any) {
      console.log(this.constructor.name, 'extractVariableValue', error.message);
    }
  }

  EstaNoVetor(vetor: any[], elemento: string): boolean {
    try {
      let isOn = false;
      for (const str of vetor) {
        if (str === elemento) {
          isOn = true;
          break;
        }
      }
      return isOn;
    } catch (error: any) {
      console.log(this.constructor.name, 'EstaNoVetor', error.message);
    }
  }

  /* Similar ao isEqual, no entanto, se os campos forem datas irá ignorar diferenças de horário */
  isEqualIgnoreTime(str1: any, str2: any): boolean {
    try {
      return this.isEqual(str1, str2, true);
    } catch (error: any) {
      console.log(this.constructor.name, 'isEqualIgnoreTime', error.message);
    }
  }


  /**
   * Verifica se a data está entre as datas de início e fim, ignorando o horário
   * @param dateToCheck Data a ser verificada
   * @param stDate Data de Início
   * @param edDate Data de Fim
   * @returns {boolean} true se a data estiver entre as datas de início e fim, false caso contrário
   */
  isBetweenIgnoreTime(dateToCheck: Date, stDate: Date, edDate: Date): boolean {
    if (!dateToCheck || !stDate || !edDate) {
      return false;
    }

    try {
      const startDate = new Date(stDate.setHours(0, 0, 0, 0));
      const endDate = new Date(edDate.setHours(23, 59, 59, 999));

      return dateToCheck >= startDate && dateToCheck <= endDate;
    } catch (error: any) {
      console.error(`${this.constructor.name}: isBetweenIgnoreTime - ${error.message}`);

      return false;
    }
  }

  isFirstDateBiggerThanSecondIgnoringTimes(date1: Date, date2: Date): boolean {
    try {
      if (!date1 || !date2) {
        return false;
      }
      const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate(), 0, 0, 0);
      const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 0, 0, 0);

      return d1.getTime() > d2.getTime();
    } catch (error: any) {
      console.log(this.constructor.name, 'isFirstDateBiggerThanSecondIgnoringTimes', error.message);
    }
    return null;
  }

  isFirstDateBiggerThanOrEqualSecondIgnoringTimes(date1: Date, date2: Date): boolean {
    try {
      if (!date1 || !date2) {
        return false;
      }
      const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate(), 0, 0, 0);
      const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 0, 0, 0);
      return d1.getTime() >= d2.getTime();
    } catch (error: any) {
      console.log(this.constructor.name, 'isFirstDateBiggerThanOrEqualSecondIgnoringTimes', error.message);
    }
    return null;
  }

  /**
   * Verifica se duas strings são iguais ignorando acentos e maiúsculas
   * também pode receber duas datas e, se assim o for, compara as datas.
   * Se um dos campos for null, retornará false.
   */
  isEqual(str1: any, str2: any, ignoreTime: boolean = false, removeSpaces: boolean = false): boolean {
    try {
      if (this.isNullOrEmpty(str1) && this.isNullOrEmpty(str2)) {
        return true;
      }
      if (!str1 || !str2) {
        return false;
      }

      const typed1 = this.getTypedValue(str1);
      const typed2 = this.getTypedValue(str2);
      if (typed1.type === EnTypedValue.Date && typed2.type === EnTypedValue.Date) {
        if (ignoreTime) {
          return this.DateToddMMYYYY(typed1.value) === this.DateToddMMYYYY(typed2.value);
        } else {
          return typed1.value.getTime() === typed2.value.getTime();
        }
      }

      // Se um dos dois indefinido, considerar diferente
      if (str1 === undefined || str2 === undefined) {
        return str1 === undefined && str2 === undefined;
      }
      // Se um dos dois nulo, considerar diferente
      if (str1 === null || str2 === null) {
        return str1 === null && str2 === null;
      }
      // Se ambos vazios considerar como igual
      if (str1.toString() === '' && str2.toString() === '') {
        return true;
      }
      if (this.IsNullOrEmpty(str1) || this.IsNullOrEmpty(str2)) {
        if (str1.toString()) {
          return false;
        }
      }
      if (removeSpaces) {
        str1 = str1?.toString().replace(/\s/g, '');
        str2 = str2?.toString().replace(/\s/g, '');
      }
      // Nos demais casos, comparar a string
      return (
        this.RemoverAcentos(str1.toString().toUpperCase()) ===
        this.RemoverAcentos(str2.toString().toUpperCase())
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'isEqual', error.message);
    }
  }

  /**
   * Retorna true se os textos forem iguais, ignorando maiúsculas e minúsculas e também acentuação.
   * Retorna o index of de txt2 procurado em txt1. Se for -1 então não foi encontrado.
   */
  CompararIgnorarCapitulacaoEAcentuacao(txtBase: string, txtAProcurar: string): number {
    try {
      const txtSemAcento1: string = this.RemoverAcentos(txtBase);
      const txtSemAcento2: string = this.RemoverAcentos(txtAProcurar);

      return txtSemAcento1?.localeCompare(txtSemAcento2);
    } catch (error: any) {
      console.log(this.constructor.name, 'CompararIgnorarCapitulacaoEAcentuacao', error.message);
    }
    return 0;
  }

  /**
   * Identifica se a str1 está contida na str2, desconsiderando acentos e capitulação
   */
  ContemSemAcentos(estaContida: string, contem: string): boolean {
    try {
      if (this.IsNullOrEmpty(contem) || this.IsNullOrEmpty(estaContida)) {
        return false;
      }
      return (
        this.RemoverAcentos(contem.toLowerCase()).indexOf(this.RemoverAcentos(estaContida.toLowerCase())) >= 0
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'ContemSemAcentos', error.message);
    }
  }

  RemoverAcentos(str: string): string {
    try {
      if (!str) {
        return null;
      }

      let strReturn = '';
      for (let i = 0; i < str.length; i++) {
        const char: string = str.charAt(i);
        switch (char) {
          case 'ã':
          case 'à':
          case 'á':
          case 'à':
          case 'ä':
            strReturn += 'a';
            break;
          case 'Ã':
          case 'À':
          case 'Á':
          case 'À':
          case 'Ä':
            strReturn += 'A';
            break;
          case 'é':
          case 'ë':
          case 'ê':
          case 'è':
            strReturn += 'e';
            break;
          case 'É':
          case 'Ë':
          case 'Ê':
          case 'È':
            strReturn += 'E';
            break;
          case 'í':
          case 'ì':
          case 'ï':
            strReturn += 'i';
            break;
          case 'Í':
          case 'Ì':
          case 'Ï':
            strReturn += 'I';
            break;
          case 'Ó':
          case 'Õ':
          case 'Ô':
            strReturn += 'O';
            break;
          case 'ó':
          case 'õ':
          case 'ô':
            strReturn += 'o';
            break;
          case 'ú':
          case 'ü':
          case 'ù':
            strReturn += 'u';
            break;
          case 'Ú':
          case 'Ü':
          case 'Ù':
            strReturn += 'U';
            break;
          case 'ç':
            strReturn += 'c';
            break;
          case 'Ç':
            strReturn += 'C';
            break;
          default:
            strReturn += char;
            break;
        }
      }
      return strReturn;
    } catch (error: any) {
      console.log(this.constructor.name, 'RemoverAcentos', error.message);
    }
  }

  /* Retorna true se _str estiver entre aspas (aspas no primeiro e no último caracter). */
  ChecaAspas(str: string): boolean {
    try {
      if (this.IsNullOrEmpty(str)) {
        return false;
      }
      str = str.toString();
      const firstChar: string = str.substr(0, 1);
      const lastChar: string = str.substr(str.length - 1, 1);
      const result: boolean = firstChar === lastChar && firstChar === '"';
      return result;
    } catch (error: any) {
      console.log(this.constructor.name, 'ChecaAspas', error.message);
    }
  }

  // Retorna a _str entre aspas (se já estivesse entre aspas, faz nada)
  AcrescentarAspas(str: string): string {
    try {
      if (this.ChecaAspas(str)) {
        return str;
      } else {
        return '"' + str + '"';
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'AcrescentarAspas', error.message);
    }
  }
  /**
   * Remove todas as marcações \r e \n da string.
   */
  getGUID(): string {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  isGUID(guid: string) {
    const regex = /.{8}-.{4}-.{4}-.{4}-.{12}/g;
    return regex.test(guid);
  }

  addMonthsUTC(date: Date, count) {
    try {
      if (!date) {
        return null;
      }
      return new Date(date.getFullYear(), date.getMonth() + count, date.getDate());
    } catch (error: any) {
      console.log(this.constructor.name, 'addMonthsUTC', error.message);
    }
  }

  addDays(date, days): Date | null {
    try {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    } catch (error: any) {
      console.log(this.constructor.name, 'addDays', error.message);
    }
  }

  isBetween(dt: any, dtStart: any, dtEnd: any): boolean {
    try {
      return new Date(dt) >= new Date(dtStart) && new Date(dt) <= new Date(dtEnd);
    } catch (error: any) {
      console.log(this.constructor.name, 'isBetween', error.message);
    }
  }

  getMonthName(date: Date, locale: string = 'pt-BR'): string {
    try {
      const month = date.toLocaleString(locale, { month: 'short' });
      return month;
    } catch (error: any) {
      console.log(this.constructor.name, 'getMonthName', error.message);
    }
  }

  getMonthYear(dt: any, locale: string = 'pt-BR'): string {
    try {
      if (!dt) {
        return null;
      }
      const date: Date = new Date(dt);
      return this.getMonthName(date, locale) + '/' + date.getFullYear();
    } catch (error: any) {
      console.log(this.constructor.name, 'getMonthYear', error.message);
    }
  }

  getDayMonth(dt: any, locale: string = 'pt-BR'): string {
    try {
      const date: Date = new Date(dt);
      const day: string = '0' + date.getDate();
      return this.getRight(day, 2) + '/' + this.getMonthName(date, locale);
    } catch (error: any) {
      console.log(this.constructor.name, 'getDayMonth', error.message);
    }
  }

  getRight(str: string, num: number): string {
    try {
      return str.slice(-num);
    } catch (error: any) {
      console.log(this.constructor.name, 'getRight', error.message);
    }
  }

  getLeft(str: string, num: number): string {
    try {
      return str.slice(0, num);
    } catch (error: any) {
      console.log(this.constructor.name, 'getLeft', error.message);
    }
  }

  // Verifica se a data fornecida esta no mês/ano atual
  isInCurrentMonth(date): boolean {
    try {
      const today = new Date();
      const month = today.getMonth();
      const year = today.getFullYear();
      const dt = new Date(date);
      return dt.getMonth() === month && dt.getFullYear() === year;
    } catch (error: any) {
      console.log(this.constructor.name, 'isInCurrentMonth', error.message);
    }
  }

  /* Atenção: número do mês baseado em 1. */
  getDaysOfMonth(year: number, month: number): IBasic[] {
    try {
      const days: IBasic[] = [];
      const dt: Date = new Date(year, month, 0); // Não adicionado +1 no mês, pois é baseado em zero.
      const lastDay = dt.getDate();
      for (let i = 1; i <= lastDay; i++) {
        days.push({ id: i, name: i.toString() });
      }
      return days;
    } catch (error: any) {
      console.log(this.constructor.name, 'getDaysOfMonth', error.message);
    }
  }

  /* Atenção: número do mês baseado em 1. */
  getDaysMonthOfMonth(year: number, month: number): IBasic[] {
    try {
      const days: IBasic[] = [];
      const dt: Date = new Date(year, month, 0); // Não adicionado +1 no mês, pois é baseado em zero.
      const lastDay = dt.getDate();
      for (let i = 1; i <= lastDay; i++) {
        const monthName = this.getMonthName(dt);
        days.push({ id: i, name: this.getRight('0' + i, 2) + '/' + monthName });
      }
      return days;
    } catch (error: any) {
      console.log(this.constructor.name, 'getDaysMonthOfMonth', error.message);
    }
  }

  getMonthNames(locale: string = 'pt-BR'): IBasic[] {
    try {
      const months: IBasic[] = [];
      for (let i = 0; i <= 11; i++) {
        const date = new Date(2016, i, 1);
        months.push({ id: i, name: this.getMonthName(date, locale) });
      }
      return months;
    } catch (error: any) {
      console.log(this.constructor.name, 'getMonthNames', error.message);
    }
  }

  dateToYYYYMMddThhmmss(strDate: any): string {
    try {
      if (!strDate) {
        return null;
      }
      const sep = '-';
      const sepH = ':';
      const dt: Date = new Date(strDate);
      return (
        dt.getFullYear() +
        sep +
        this.addL0(dt.getMonth() + 1) +
        sep +
        this.addL0(dt.getDate()) +
        'T' +
        this.addL0(dt.getHours()) +
        sepH +
        this.addL0(dt.getMinutes()) +
        sepH +
        this.addL0(dt.getSeconds())
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToYYYYMMddThhmmss', error.message);
    }
  }

  dateToddMMYYYYhhmmss(strDate: any, sep: string = '/', showSeconds: boolean = true): string {
    try {
      if (!strDate) {
        return null;
      }
      const sepH = ':';
      const dt: Date = new Date(strDate);
      const sec = showSeconds ? sepH + this.addL0(dt.getSeconds()) : '';
      return (
        this.addL0(dt.getDate()) +
        sep +
        this.addL0(dt.getMonth() + 1) +
        sep +
        dt.getFullYear() +
        ' ' +
        this.addL0(dt.getHours()) +
        sepH +
        this.addL0(dt.getMinutes()) + sec
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToYYYYMMddThhmmss', error.message);
    }
  }

  dateTohhmmss(strDate: any, showSeconds: boolean = true, sepH: string = ':'): string {
    try {
      if (!strDate) {
        return null;
      }
      const dt: Date = new Date(strDate);
      return (
        this.addL0(dt.getHours()) +
        sepH +
        this.addL0(dt.getMinutes()) +
        (showSeconds ? sepH + this.addL0(dt.getSeconds()) : '')
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToYYYYMMddThhmmss', error.message);
    }
  }

  dateToUTChhmmss(strDate: any, showSeconds: boolean = true, sepH: string = ':'): string {
    try {
      if (!strDate) {
        return null;
      }
      const dt: Date = new Date(strDate);
      return (
        this.addL0(dt.getUTCHours()) +
        sepH +
        this.addL0(dt.getMinutes()) +
        (showSeconds ? sepH + this.addL0(dt.getSeconds()) : '')
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToYYYYMMddThhmmss', error.message);
    }
  }

  dateToddMMYYYY(strDate: any): string {
    try {
      if (strDate === undefined || strDate === '' || strDate === null) {
        return '';
      }
      const sep = '/';
      const dt: Date = new Date(strDate);
      return this.addL0(dt.getDate()) + sep + this.addL0(dt.getMonth() + 1) + sep + dt.getFullYear();
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToddMMYYYY', error.message);
    }
  }

  dateToYYYYMMdd(strDate: any, sep: string = '-'): string {
    try {
      if (strDate === undefined || strDate === '' || strDate === null) {
        return '';
      }
      const dt: Date = new Date(strDate);
      return dt.getFullYear() + sep + this.addL0(dt.getMonth() + 1) + sep + this.addL0(dt.getDate());
    } catch (error: any) {
      console.log(this.constructor.name, 'dateToYYYYMMdd', error.message);
    }
  }

  addFormatDate() {
    try {
      const data = new Date();
      const dia = data.getDate().toString();
      const diaF = (dia.length === 1) ? '0' + dia : dia;
      const mes = (data.getMonth() + 1).toString(); // +1 pois no getMonth Janeiro começa com zero.
      const mesF = (mes.length === 1) ? '0' + mes : mes;
      const anoF = data.getFullYear();
      return diaF + "/" + mesF + "/" + anoF;
    } catch (error: any) {
      console.log(this.constructor.name, 'addFormatDate', error.message);
    }
    return null;
  }

  // Adiciona um zero a esquerda
  addL0(str: any, numOfDig: number = 2): string {
    try {
      if (typeof str !== 'string') {
        str = str.toString();
      }
      return this.getRight('0' + str, 2);
    } catch (error: any) {
      console.log(this.constructor.name, 'addL0', error.message);
    }
  }

  isSameDate(date1: Date, date2: Date): boolean {
    try {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'isSameDate', error.message);
    }
  }

  /*Converte número em português para padrão computacional
  //Se não for possível converter, retorna zero. */
  convertNumber(str: any): number {
    try {
      let num = 0;
      const typed = this.getTypedValue(str);
      num = typed.value;
      try {
        // num = parseFloat((str as string).replace(".", "").replace(",", "."));
      } catch (err) { }
      return num;
    } catch (error: any) {
      console.log(this.constructor.name, 'convertNumber', error.message);
    }
  }

  // Verifica se o valor é SIM, true, 1, string, ou booleano
  convertBoolean(str: any): boolean {
    try {
      if (typeof str === 'boolean') {
        return str;
      }
      if (typeof str === 'number') {
        return str <= 0 ? false : true;
      }
      if (typeof str === 'string') {
        if (str.toUpperCase() === 'SIM' || str.toUpperCase() === 'TRUE' || str.toUpperCase() === 'VERDADEIRO') {
          return true;
        }
      }
      return false;
    } catch (error: any) {
      console.log(this.constructor.name, 'convertBoolean', error.message);
    }
  }

  contem(fullText?: string, search?: string): boolean {
    try {
      return this.tratar(fullText)?.indexOf(this?.tratar(search)) >= 0;
    } catch (error: any) {
      console.log(this.constructor.name, 'contem', error.message);
    }
  }

  isNullOrEmpty(str: any): boolean {
    try {
      if (str === 'undefined') {
        return true;
      }
      if (str === undefined) {
        return true;
      }
      if (str === 'null') {
        return true;
      }
      if (str === null) {
        return true;
      }
      if (str?.toString() === '') {
        return true;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'isNullOrEmpty', error.message);
    }
    return false;
  }

  // Utilizar esse método dos dois lados da expressão de comparação para ficar caseinsensitive e desconsiderar acentos
  tratar(str: string): string {
    try {
      if (!str) {
        return str;
      }
      str = str.toLocaleUpperCase();
      for (const obj of this.replace) {
        str = str.replace(obj.de, obj.para);
      }
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'tratar', error.message);
    }
  }

  // Retorna uma string com o nome de coluna que pode ser MES/ANO, ANO ou DIA/MES
  getClm(dateDue, periodTypeId): string {
    try {
      let column = '';
      switch (periodTypeId) {
        default:
        case 1:
          column = this.getDayMonth(dateDue);
          break;
        case 2:
          column = this.getMonthYear(dateDue);
          break;
        case 3:
          column = new Date(dateDue).getFullYear().toString();
          break;
      }
      return column;
    } catch (error: any) {
      console.log(this.constructor.name, 'getClm', error.message);
    }
  }

  // Retorna "-" se não informado
  getNaoInformadoMask(str: string): string {
    try {
      return this.isGEEmpty(str) ? '-' : str;
    } catch (error: any) {
      console.log(this.constructor.name, 'getNaoInformadoMask', error.message);
    }
  }

  isGEEmpty(str: string): boolean {
    try {
      return (
        str.toUpperCase() === this.GE_NOT_INFORMED ||
        str === '' ||
        str.toUpperCase() === this.GE_EMPTY ||
        str === undefined
      );
    } catch (error: any) {
      console.log(this.constructor.name, 'isGEEmpty', error.message);
    }
  }

  /**
   * Adiciona um tempo a uma data
   * @param datepart y adicionará anos, m meses, d dias
   * @param number
   * @param date
   * @return
  */
  DateAdd(datepart: string = '', nmb: number = 0, date: Date = null): Date | null {
    try {
      if (date == null) {
        /* Default to current date. */
        date = new Date();
      }
      const returnDate = new Date(date.valueOf());

      // trace("ReturnDate:"+returnDate);
      // trace("datePart:"+datepart);
      switch (this.RemoverAspas(datepart).toLowerCase()) {
        case 'y':
          returnDate.setFullYear(+returnDate.getFullYear() + +nmb);
          // returnDate["fullYear"] += number;
          break;
        case 'm':
          returnDate.setMonth(+returnDate.getMonth() + +nmb);
          // returnDate["month"] += number;
          break;
        case 'w':
          returnDate.setDate(+returnDate.getDate() + +nmb * 6);
          // returnDate["date"] += number * 6;
          break;
        case 'd':
          returnDate.setDate(+returnDate.getDate() + +nmb);
          break;
        default:
          /* Unknown date part, do nothing. */
          break;
      }
      return returnDate;
    } catch (error: any) {
      console.log(this.constructor.name, 'DateAdd', error.message);
    }
  }

  /* Gera um vetor com todos os dias contidos num intervalo de datas. */
  generateDates(dtStart: Date, dtEnd: Date): Date[] {
    try {
      const dts = new Array<Date>();
      const numbOfDays = this.dateDiffDays(dtStart, dtEnd);
      let currentDt = dtStart;
      for (let i = 0; i < numbOfDays; i++) {
        dts.push(currentDt);
        currentDt = this.DateAdd('d', 1, currentDt);
      }
      return dts;
    } catch (error: any) {
      console.log(this.constructor.name, 'generateDates', error.message);
    }
    return null;
  }

  /**
   * Se a string estiver entre aspas (início e fim) remove, senão retorna a própria string.
   * Não remove aspas no meio da string.
   * @param _str
   * @return
   *
  */
  RemoverAspas(str: string): string {
    try {
      if (this.ChecaAspas(str)) {
        return this.RemoveLastChar(this.RemoveFirstChar(str));
      } else {
        return str;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'RemoverAspas', error.message);
    }
  }

  /**
   * Remove todas as marcações \r e \n da string.
   */
  RemoveLineBreaks(text: string): string {
    try {
      text = this.RemoveAll(text, '\r');
      return this.RemoveAll(text, '\n');
    } catch (error: any) {
      console.log('Global', 'RemoveLineBreaks', 'Error: ' + error.message);
    }
    return null;
  }

  /**
   * Tenta converter um número para o padrão americano.
    Tentará identificar se já está no padrão americano, baseado no
    número de casas decimais depois do ponto.
   * @param _number
   * @param _removeNonDigit: removerá todos os símbolos que não sejam números ou o separador de milhar .
   * @return
   */
  ConvertToAmericanNumber(nmb: any, numDecimalPlacesIn: number = 2, removeNonDigit: boolean = false): number {
    try {
      if (this.isNullOrEmpty(nmb)) {
        return 0;
      }
      if (this.IsAmericanNumber(nmb, numDecimalPlacesIn)) {
        // Significa que existe um único ponto (potencialmente já
        // está no padrão americado). Se for não tem ponto e se for maior mais de um ponto
        return parseFloat(nmb);
      }
      let strNum = nmb.toString().replace('/./g', '').replace(',', '.');
      if (removeNonDigit) {
        strNum = this.removeNonDigit(strNum);
      }
      const convertedNumber: number = parseFloat(strNum);
      return convertedNumber;
    } catch (error: any) {
      console.log(this.constructor.name, 'ConvertToAmericanNumber', error.message);
    }
  }

  /* Removerá todos os símbolos que não sejam números ou o separador de milhar . */
  removeNonDigit(str: string): string {
    try {
      str = str.replace(/[^\d\.]/g, '');
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'removeNonDigit', error.message);
    }
  }

  removeNumber(str: string): string {
    try {
      const number = this.removeNonDigit(str);
      str = str.replace(number, '');
      return str;
    } catch (error: any) {
      console.log(this.constructor.name, 'removeNumber', error.message);
    }
  }

  IsAmericanNumber(nmb: any, numDecimalPlaces: number = 2): boolean {
    try {
      if (this.isNullOrEmpty(nmb)) {
        return false;
      }

      const regexNum = /^-*[0-9,\,,\.]+$/;
      const isNum = regexNum.test(nmb);
      if (!isNum) {
        return false;
      }

      return !isNaN(nmb);
    } catch (error: any) {
      console.log(this.constructor.name, 'IsAmericanNumber', error.message);
    }
  }

  /* Checa se o número é um inteiro (ou seja, positivo, zero ou negativo mas sem casas decimais). */
  isInt(n): boolean {
    return Number(n) === n && n % 1 === 0;
  }

  /* Checa se o número é um fload (ou seja, positivo, zero ou negativo mas com casas decimais). */
  isFloat(n): boolean {
    return Number(n) === n && n % 1 !== 0;
  }

  /**
   * Tenta converter um número para o padrão brasileiro.
   Tentará identificar se já está no padrão americano,
    baseado no número de casas decimais depois do ponto.
   * @param _number
   * @param _numDecimalPlacesIn: número de casas decimais
   *  esperado (usado na comparação para determinar se está
   * no padrão americano ou brasileiro) na entrada do dado
   * @param _numDecimalPlacesOut: Número de casas decimais com que o número será retornado
   * @return
   */
  ConvertToBrazilianNumber(
    nmb: any,
    numDecimalPlacesIn: number = 2,
    numDecimalPlacesOut: number = 2
  ): string {
    try {
      if (!this.IsAmericanNumber(nmb, numDecimalPlacesIn)) {
        nmb = this.ConvertToAmericanNumber(nmb, numDecimalPlacesIn).toString();
      }
      nmb = Number(nmb).toFixed(numDecimalPlacesOut);
      const convertedNumber: string = nmb.toString().replace(',', '').replace('.', ',');
      return convertedNumber;
    } catch (error: any) {
      console.log(this.constructor.name, 'ConvertToBrazilianNumber', error.message);
    }
  }

  /* Faz o processo inverso de getId: a partir do id retorna a VariavelNo */
  getVariavelNoFromId(id: string): number {
    try {
      return parseInt(id.toString().replace('V_', ''), 10);
    } catch (error: any) {
      console.log(this.constructor.name, 'getVariavelNoFromId', error.message);
    }
    return null;
  }

  /* Clona um objeto do tipo referência. Copia as propriedades e valores, mas não apontará para a mesma posição de memória. */
  cloneObj(obj: any): any {
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch (error: any) {
      console.log(this.constructor.name, 'cloneObj', error.message);
    }
  }

  /* Retorna uma lista de nomes fictícios para médicos */
  getNamesDoctorFiction(quantity: number): string[] {
    try {
      const names: string[] = [];
      for (let i = 0; i < quantity; i++) {
        const rnd = Math.round(Math.random() * this.namesDoctorFiction.length);
        names.push(this.namesDoctorFiction[rnd]);
      }
      return names;
    } catch (error: any) {
      console.log(this.constructor.name, 'getNamesDoctorFiction', error.message);
    }
  }

  /*Retorna um valor entre 0 e 1 (percentual) sobre o quão semelhante são as strings.
   * https://stackoverflow.com/questions/10473745/compare-strings-javascript-return-of-likely
   */
  similarity(s1: string, s2: string): number {
    try {
      let longer = s1;
      let shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      const longerLength = longer.length;
      if (longerLength === 0) {
        return 1.0;
      }
      return (longerLength - this.editDistance(longer, shorter)) / longerLength;
    } catch (error: any) {
      console.log(this.constructor.name, 'similarity', error.message);
    }
  }

  extractFileNameFromPath(path: string): { fileName: string, extension: string } {
    try {
      const fileName = path?.replace(/^.*(\\|\/|\:)/, '');
      const extension = fileName ? fileName?.substr(fileName?.lastIndexOf('.') + 1) : '';
      return {
        fileName,
        extension
      };
    } catch (error: any) {
      console.log(this.constructor.name, 'extractFileNameFromPath', error.message);
    }
    return null;
  }

  /* Método auxiliar o qual o similarity depende. */
  protected editDistance(s1, s2) {
    try {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      const costs = new Array();
      for (let i = 0; i <= s1.length; i++) {
        let lastValue = i;
        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else {
            if (j > 0) {
              let newValue = costs[j - 1];
              if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              }
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) {
          costs[s2.length] = lastValue;
        }
      }
      return costs[s2.length];
    } catch (error: any) {
      console.log(this.constructor.name, 'editDistance', error.message);
    }
  }

  /* Pega um texto e remove acentos, espaços, preposições, etc. */
  convertLabelToProperty(str): string {
    try {
      let res = this.removeDiacritics(str);
      res = this.removeConjuncao(res);
      const arr = res.split(' ');
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].substr(0, 1).toUpperCase() + arr[i].substring(1);
      }
      res = arr.join('');
      return res.substr(0, 1).toLowerCase() + res.substring(1);
    } catch (error: any) {
      console.log(this.constructor.name, 'convertLabelToProperty', error.message);
    }
  }

  primeiraMaiuscula(str: string, allUpperCase: boolean = true): string {
    let isFirst = true;
    return `${str.split(' ')
      .map(m => {
        if ((isFirst || allUpperCase) && !this.isConjuncao(m)) {
          isFirst = false;
          return `${m.substr(0, 1).toUpperCase()}${m.substr(1).toLowerCase()}`;
        } else {
          return m.toLowerCase();
        }
      }).join(' ')}`;
  }

  isConjuncao(str: string): boolean {
    return this.exprConjuncao.test(str);
  }

  removeConjuncao(str: string): string {
    try {
      return str.replace(/\s(de|do|o|a|e|dos|da|das|de|para|se)\s/g, '');
    } catch (error: any) {
      console.log(this.constructor.name, 'removeConjuncao', error.message);
    }
  }

  getInitials(name: string): string {
    try {
      if (name) {
        name = this.removeConjuncao(name);
        return `${name.split(' ').map(m => m.substr(0, 1).toUpperCase()).join('.')}.`;
      }
    } catch (error: any) {
      console.log(this.constructor.name, 'getInitials', error.message);
    }
    return name;
  }

  removeDiacritics(str: string): string {
    try {
      return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (error: any) {
      console.log(this.constructor.name, 'removeDiacritics', error.message);
    }
  }

  /* Retorna um valor booleano a partir da comparação de um valor do tipo 'SIM'. */
  getBoolean(value: string | boolean, yesValue: string = 'SIM'): boolean | null {
    try {
      if ((value === null) || (value === undefined)) {
        return null;
      }
      if (typeof value === 'boolean') {
        return value;
      }
      return value.toUpperCase() === yesValue.toUpperCase() ? true : false;
    } catch (error: any) {
      console.log(this.constructor.name, 'getBoolean', error.message);
    }
    return null;
  }

  /* Faz o inverso de getBoolean */
  getReverseBoolean(value: boolean, yesValue: string = 'Sim', noValue: string = 'Não'): string {
    try {
      return value ? yesValue : noValue;
    } catch (error: any) {
      console.log(this.constructor.name, 'getReverseBoolean', error.message);
    }
    return 'Não';
  }

  validarCNPJ(cnpj: string): boolean {
    try {
      cnpj = cnpj.replace(/[^\d]+/g, '');
      // Valida a quantidade de caracteres
      if (cnpj.length !== 14) {
        return false;
      }
      // Elimina inválidos com todos os caracteres iguais
      if (/^(\d)\1+$/.test(cnpj)) {
        return false;
      }
      // Cáculo de validação
      const t = cnpj.length - 2;
      const d = cnpj.substring(t);
      const d1 = parseInt(d.charAt(0), 10);
      const d2 = parseInt(d.charAt(1), 10);
      const calc = (x: number) => {
        const n: any = cnpj.substring(0, x);
        let y = x - 7;
        let s = 0;
        let r = 0;
        for (let i = x; i >= 1; i--) {
          s += n.charAt(x - i) * y--;
          if (y < 2) {
            y = 9;
          }
        }
        r = 11 - s % 11;
        return r > 9 ? 0 : r;
      };
      return calc(t) === d1 && calc(t + 1) === d2;
    } catch (error: any) {
      console.log(this.constructor.name, 'validarCNPJ', error.message);
    }
    return false;
  }

  validarCPF(strCPF: string): boolean | null {
    try {
      if (!strCPF) {
        return null;
      }

      let soma: number;
      let resto: number;
      strCPF = strCPF.toString();
      strCPF = strCPF.replace(/[^\d]+/g, '');
      soma = 0;
      if (strCPF === '00000000000') { return false; }
      for (let i = 1; i <= 9; i++) { soma = soma + parseInt(strCPF.substring(i - 1, i), 10) * (11 - i); }
      resto = (soma * 10) % 11;
      if ((resto === 10) || (resto === 11)) { resto = 0; }
      if (resto !== parseInt(strCPF.substring(9, 10), 10)) { return false; }
      soma = 0;
      for (let i = 1; i <= 10; i++) { soma = soma + parseInt(strCPF.substring(i - 1, i), 10) * (12 - i); }
      resto = (soma * 10) % 11;
      if ((resto === 10) || (resto === 11)) { resto = 0; }
      if (resto !== parseInt(strCPF.substring(10, 11), 10)) { return false; }
      return true;
    } catch (error: any) {
      console.log(this.constructor.name, 'validarCPF', error.message);
    }
    return false;
  }

  separateValueFromUnity(dosage: string, numbStrUnity: string[] = null): { value: number, unity: string } | null {
    try {
      if (this.isNullOrEmpty(dosage)) {
        return { value: 0, unity: '' };
      }
      if (dosage.includes('#')) {
        const split = dosage.split('#');
        if (split.length === 2) {
          return { value: parseFloat(split[0]), unity: split[1] };
        }
      }
      numbStrUnity = numbStrUnity || [
        'g/1mL', 'g/10mL', 'g/25mL', 'g/5mL', 'g/1mg',
        'g/2mg', 'mg/1,1mL', 'mg/1.1mL', 'mg/10mL', 'mg/1mL',
        'mg/2,5mL', 'mg/2.5mL', 'mg/30mL', 'mg/5mL', 'UI/mLX4mL'
      ];
      const idxUnity = numbStrUnity.reduce((res, unity, idx) => dosage.toUpperCase().includes(unity.toUpperCase()) ? idx : res, -1);
      if (idxUnity >= 0) {
        return {
          value: Number(dosage.replace(numbStrUnity[idxUnity], '').trim()),
          unity: numbStrUnity[idxUnity]
        }
      }

      dosage = dosage.replace(/\s/g, '');
      let number = '';
      const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'];
      for (let i = 0; i < dosage?.length; i++) {
        number = chars.includes(dosage[i]) ? `${number}${dosage[i]}` : number;
      }
      number = number.replace(/\./, '');
      const idx = dosage.indexOf(number) + number.length;
      return { value: number ? +number : 0, unity: dosage?.substring(idx) || '' };
    } catch (error: any) {
      console.log(this.constructor.name, 'separateValueFromUnity', error.message);
    }
    return null;
  }

  getDateUTCToLocal(data: Date) {
    return new Date(data.toLocaleDateString())
  }

  getDateLocalToUTC(data: Date) {
    return new Date(data.toISOString());
  }

  getTimeLocalToUTC(time: String) {
    // Cria um objeto Date com a data atual
    let date = new Date();

    // Extrai as horas e minutos da string de tempo
    let [hours, minutes] = time.split(":");

    // Define as horas e minutos para o objeto Date
    date.setHours((Number(hours)), (Number(minutes)));

    // Converte para UTC usando toISOString e extrai a parte do tempo
    let utcTime = date.toISOString().split("T")[1].substring(0, 5);

    return utcTime;
  }

  /**
   * Compara as datas de início e fim com a data atual. Se não houver data de fim, compara apenas com a data de Início.
   * @param dateStart
   * @param dateEnd
   * @returns Boolean
   */
  compareDatesToIcons(dateStart: Date, dateEnd: Date): boolean {
    const today = new Date();

    if (dateStart && dateEnd) {
      return this.isBetweenIgnoreTime(today, dateStart, dateEnd)
    } else if (dateStart) {
      return dateStart.getTime() <= today.getTime();
    }

    return false;
  }
}
